/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 55);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = __webpack_require__(37)['default'];


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      column = undefined;
  if (loc) {
    line = loc.start.line;
    column = loc.start.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', {
          value: column,
          enumerable: true
        });
      } else {
        this.column = column;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return throttle; });
/* unused harmony export debounce */
function getParameter(param, where, separator, splitter) {
  var query = where ? where : window.location.search.substring(1);
  var vars = query.split(separator ? separator : "&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split(splitter ? splitter : "=");
    if(pair[0] == param) {
      return pair[1];
    }
  }
  return false;
};

function getLocale() {
  if (window.DEBUG && getParameter("lang")) {
    return getParameter("lang");
  } else {
    return navigator.language.split("-")[0];
  }
}

function throttle(fn, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}



/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(1);

var _exception = __webpack_require__(2);

var _exception2 = _interopRequireDefault(_exception);

var _helpers = __webpack_require__(40);

var _decorators = __webpack_require__(38);

var _logger = __webpack_require__(48);

var _logger2 = _interopRequireDefault(_logger);

var VERSION = '4.0.11';
exports.VERSION = VERSION;
var COMPILER_REVISION = 7;

exports.COMPILER_REVISION = COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
function map(id, config) {
	var script,
		config = config || {},
		API_KEY = config.API_KEY,
		place = config.place,
		center = config.center || place,
		label = config.title,
		zoom = config.zoom || 15;

	function applyMap() {
		var map = new google.maps.Map(document.getElementById(id), {
			zoom: zoom,
			center: center,
			disableDefaultUI: false,
			scaleControl: true,
			mapTypeControl: false,
			zoomControl: true,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		if (label) {
			label = {
				text: config.title,
				fontSize: "14px"
			};
		}

		var marker = new google.maps.Marker({
			position: place,
			map: map,
		    animation: google.maps.Animation.DROP,
			labelClass: "labels",
			label: label
		});
	}


	if (!window.google || !window.google.maps || !window.google.maps.Map) {
		script = document.createElement('script');
		script.setAttribute('src','https://maps.googleapis.com/maps/api/js?key=' + API_KEY + '&callback=initMap');
		script.setAttribute('async','');
		script.setAttribute('defer','');

		document.head.appendChild(script);

		window.initMap = function () {
			applyMap();
		}
	} else {
		applyMap(); // reinitialize map or check if already is ???
	}

}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forms;
function forms() {
	[].forEach.call(document.querySelectorAll(".form-input"), function (elem) {
		elem.setAttribute("data-bad-input", "Required");
		elem.setAttribute("data-custom-error", "Required");
		elem.setAttribute("data-pattern-mismatch", "Required");
		elem.setAttribute("data-range-overflow", "Required");
		elem.setAttribute("data-range-underflow", "Required");
		elem.setAttribute("data-step-mismatch", "Required");
		elem.setAttribute("data-too-long", "Required");
		elem.setAttribute("data-too-short", "Required");
		elem.setAttribute("data-type-mismatch", "Required");
		elem.setAttribute("data-value-missing", "Required");
	});

	hyperform.addTranslation("en", {
		TextTooLong: "Required",
		ValueMissing: "Required"
	});

	hyperform.setLanguage("en");

	/* change Hyperform's renderer to write into the global error div */
	hyperform.setRenderer('attachWarning', function(warning, element) {
		/*if (element.labels && element.labels.length) {
			warning.insertAdjacentText('afterbegin', element.labels[0].textContent);
		}*/
		element.parentNode.appendChild(warning);
	});


	window.onlyNumbers = function(e) {
	    if (e && e.keyCode) {
	    	if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105 || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 46)) {
	    		// numbers, then do nothing
	        } else {
	        	console.log("preventDefault")
	        	e.preventDefault();
	        	return false;
	        }
	    } else {
	    	console.log("preventDefault")
	    	e.preventDefault();
	    	return false;
	    }
	};

	window.checkNumbers = function (input) {
		var resultValue = input.value.replace(/~`´¨/, '')
		console.log(resultValue)
	}

	hyperform(window, {
		preventImplicitSubmit: true,
		revalidate: 'hybrid'
	});


	hyperform.addTranslation("en",{
		TextTooLong:"Too much content",
		TextTooShort:"Required",
		ValueMissing:"Required",
		CheckboxMissing:"Required",
		RadioMissing:"Required",
		FileMissing:"Required",
		SelectMissing:"Required",
		InvalidEmail:"Wrong format",
		InvalidURL:"Wrong format",
		InvalidDate:"Wrong format",
		PatternMismatch:"Wrong format",
		PatternMismatchWithTitle:"Wrong format",
		NumberRangeOverflow:"Wrong format",
		DateRangeOverflow:"Wrong format",
		TimeRangeOverflow:"Wrong format",
		NumberRangeUnderflow:"Wrong format",
		DateRangeUnderflow:"Wrong format",
		TimeRangeUnderflow:"Wrong format",
		StepMismatch:"Wrong format",
		StepMismatchOneValue:"Wrong format",
		BadInputNumber:"Wrong format",
		"Please match the requested type.": "Wrong format",
		"Please comply with all requirements.": "Wrong format",
		"Please lengthen this text to %l characters or more (you are currently using %l characters).": "Wrong format",
		"Please use the appropriate format.": "Wrong format",
		"Please enter a comma separated list of email addresses.": "Wrong format",
		"Please select a file of the correct type.": "Wrong format",
		"Please select one or more files.": "Wrong format",
		"any value":"Required",
		"any valid value":"Wrong format",
	});
	hyperform.setLanguage("en");
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slider;
var tmrAuto = [], tmrSlide = [], items = [], prev = [];

function detectGlobalSwipes() {
	// general touch events
	window.currentY = null;
	window.currentX = null;
	window.lastX = null;
	window.lastY = null;

	document.addEventListener("touchstart", function (e) {
		window.currentY = e.touches[0].clientY;
		window.currentX = e.touches[0].clientX;
	}, false);
	document.addEventListener("touchmove", function (e) {
		window.lastY = e.touches[0].clientY;
		window.lastX = e.touches[0].clientX;
	}, false);
}

function slideTo(config) {
	var slider = config.slider,
		index = config.index,
		callback = config.callback || function () {},
		direction = config.direction || 1,
		paginators = slider.parentNode.querySelectorAll(".slider-paginator .slider-index"),
		speed = parseInt(slider.getAttribute("data-slider-speed"), 10),
		sliderPrevPos = parseInt(slider.getAttribute("data-slider-position"), 10),
		sliderIndex = parseInt(slider.getAttribute("data-slider-index"), 10);

	if (index !== sliderPrevPos) {
		prev[sliderIndex] = sliderPrevPos;
		slider.setAttribute("data-slider-position", index);
		slider.classList.remove("left");
		slider.classList.remove("right");

		if (sliderPrevPos < index) {
			slider.classList.add("right");
		} else {
			slider.classList.add("left");
		}

		[].forEach.call(items[sliderIndex], function(item, i) {
			item.classList.remove("active");
			item.classList.remove("leaving");
		});

		items[sliderIndex][prev[sliderIndex]].classList.add("leaving");
		items[sliderIndex][index].classList.add("active");

		[].forEach.call(paginators, function(paginator, i) {
			(i === index) ? paginator.classList.add("active") : paginator.classList.remove("active");
		});

		clearTimeout(tmrSlide[sliderIndex]);
		tmrSlide[sliderIndex] = setTimeout(function () {
			[].forEach.call(items[sliderIndex], function(item, i) {
				item.classList.remove("leaving");
			});
		}, speed);
	}

	callback({
		slider: slider,
		index: index
	});
}

function slideNext(slider, callback) {
	var index = parseInt(slider.getAttribute("data-slider-position"), 10),
		length = slider.querySelectorAll(".slider-item").length;
	if (index < length - 1) {
		slideTo({slider: slider, index: ++index, callback: callback});
	} else {
		slideTo({slider: slider, index: 0, callback: callback});
	}
}

function slidePrev(slider, callback) {
	var index = parseInt(slider.getAttribute("data-slider-position"), 10),
		length = slider.querySelectorAll(".slider-item").length;
	if (index === 0) {
		slideTo({slider: slider, index: length - 1, callback: callback});
	} else {
		slideTo({slider: slider, index: --index, callback: callback});
	}
}

function swipesGestures(slider) {
	slider.addEventListener("touchend", function (e) {
		if (window.currentX - window.lastX > 80 && window.lastX !== null) {
			disableTimer(slider);
			slideNext(slider);
		} else if (window.currentX - window.lastX < -80 && window.lastX !== null) {
			disableTimer(slider);
			slidePrev(slider);
		}
	}, false);
}

function autoTimer(slider, timer, callback) {
	var sliderIndex = parseInt(slider.getAttribute("data-slider-index"), 10);
	tmrAuto[sliderIndex] = setInterval(function () {
		slideNext(slider, callback);
	}, timer);
}

function disableTimer(slider) {
	var sliderIndex = parseInt(slider.getAttribute("data-slider-index"), 10);
	clearInterval(tmrAuto[sliderIndex]);
}

function slider(elem, config) {
	var config = config || {},
		timer = config.timer || 3000,
		speed = config.speed || 500,
		callback = config.callback;

	detectGlobalSwipes();

	[].forEach.call(elem, function(slider, index) {
		var style = document.createElement('style'),
			container, paginators, numItems;

		style.type = 'text/css';
		style.innerHTML = "[data-slider-index=\"" + index + "\"] .slider-item.leaving, [data-slider-index=\"" + index + "\"] .slider-item.active { transition: all " + speed + "ms; }";
		document.querySelector('head').appendChild(style);
    	
    	if (slider.getAttribute("initialized") === "true") {
    		slideTo({slider: slider, index: 0, callback: callback});
    		return;
    	}

    	items[index] = slider.querySelectorAll(".slider-item");
    	items[index][0].classList.add("active");
    	numItems = items[index].length;

    	slider.setAttribute("data-slider-position", 0);
    	slider.setAttribute("data-slider-speed", speed);
    	slider.setAttribute("data-slider-index", index);

    	container = slider.parentNode;
    	paginators = container.querySelectorAll(".slider-paginator .slider-index");

		[].forEach.call(paginators, function(paginator) {
			paginator.onclick = function (e) {
				e.stopPropagation();
				e.preventDefault();
				disableTimer(slider);
				slideTo({slider: slider, index: parseInt(this.getAttribute("data-index"), 10), callback: callback});
			}
		});
		autoTimer(slider, timer, callback);
		swipesGestures(slider);
    	slider.setAttribute("initialized", "true");
	});
	
}



/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

window.isMobile = false;
window.$html = document.querySelector("html");
(function () {

	function getOrientation() {
		var portrait = false;
		if (window.matchMedia) {
			portrait = window.matchMedia("(orientation: portrait)").matches
		} else if (window.orientation && !isAndroid) {
			portrait = window.orientation === 0 || window.orientation === 180
		} else {
			portrait = window.innerHeight >= window.innerWidth;
		}
		return !portrait ? 'landscape' : 'portrait'
	}

	function isSafari() {
		var ua = navigator.userAgent.toLowerCase(); 
		if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
			return true;
		} else {
			return false;
		}
	}

	// maybe http://hgoebl.github.io/mobile-detect.js/ is overkill !!!!!

	// http://detectmobilebrowsers.com/ (changed window.location=b ===> window.isMobile=true;)
	(function(a,b){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))window.isMobile=true;})(navigator.userAgent||navigator.vendor||window.opera,'http://detectmobilebrowser.com/mobile');

	function supportsTransitions() {
		var b = document.body || document.documentElement,
			s = b.style,
			p = 'transition';
		if (typeof s[p] == 'string') { return true; }
		// Tests for vendor specific prop
		var v = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];
		p = p.charAt(0).toUpperCase() + p.substr(1);

		for (var i=0; i<v.length; i++) {
			if (typeof s[v[i] + p] == 'string') { return true; }
		}
		return false;
	}

	/* from modernizr */
	function createElement() {
		if (typeof document.createElement !== 'function') {
			// This is the case in IE7, where the type of createElement is "object".
			// For this reason, we cannot call apply() as Object is not a Function.
			return document.createElement(arguments[0]);
		} else if (document.documentElement.nodeName.toLowerCase() === 'svg') {
			return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
		} else {
			return document.createElement.apply(document, arguments);
		}
	}

	window.isEdge = /Edge/.test(navigator.userAgent);

	window.isIE11 = !(window.ActiveXObject) && "ActiveXObject" in window;
	window.isIE10 = false;
	/*@cc_on
		 if (/^10/.test(@_jscript_version)) {
				 isIE10 = true;
		 }
	@*/


	window.hasTransitions = supportsTransitions();
	window.isTouch = !!(typeof document.body.ontouchstart !== 'undefined' || typeof window.ontouchstart !== 'undefined' || typeof document.documentElement.ontouchstart !== 'undefined');
	window.isTablet = window.isTouch && (navigator.userAgent.match(/tablet|Android|BlackBerry|iPad|Opera Mini|IEMobile/i) !== null) && (window.innerWidth > 640) && (window.innerWidth < 1350);
	window.isiPad = window.isTouch && navigator.userAgent.match(/iPad/i) !== null && navigator.userAgent.match(/Android/i) == null;
	window.isiPhone = window.isTouch && window.isMobile && navigator.userAgent.match(/iPhone/i) !== null && navigator.userAgent.match(/Android/i) == null;
	window.isAndroid = window.isTouch && !window.isiPad && !window.isiPhone && navigator.userAgent.match(/Android/i) !== null;
	window.isSafariDesktop = isSafari() && !isiPhone && !isiPad;

	if (isMobile) {
		window.$html.classList.add("mobile");
		if (isiPhone) {
			window.$html.classList.add("iphone");
		}

	} else if (isTablet) {
		window.$html.classList.add("tablet");
		if (isiPad) {
			window.$html.classList.add("ipad");

		}
	} else {
		window.$html.classList.add("desktop");
	}

	if (isMobile || isTablet) {
		$html.classList.remove("landscape");
		$html.classList.remove("portrait");
		$html.classList.add(getOrientation());
		window.addEventListener("orientationchange", function () {
			$html.classList.remove("landscape");
			$html.classList.remove("portrait");

			$html.classList.add(getOrientation());
		}, false);
	}

	if (isAndroid) {
		window.$html.classList.add("android");
	}

	if (hasTransitions) {
		window.$html.classList.add("transitions");
	}

	if ('download' in createElement('a')) {
		window.$html.classList.add("download");
	}

	if (/*@cc_on!@*/false) {
		window.$html.classList.add("ie");
		window.$html.classList.add("ie10");
	}

	if (!(window.ActiveXObject) && "ActiveXObject" in window) {
		window.$html.classList.add("ie");
		window.$html.classList.add("ie11");
	}

	if (window.isEdge) {
		window.$html.classList.add("ie");
		window.$html.classList.add("edge");
	}

	window.$html.classList.add(isTouch ? "touch" : "no-touch");

	if (isAndroid) {
		// keyboard pushing site up fix
		setTimeout(function () {
			var viewheight = window.innerHeight;
			var viewwidth = window.innerWidth;
			var viewport = document.querySelector("meta[name=viewport]");
			viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");
		}, 500);
	}
})();



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = metrics;
function metrics() {
	// meter todo con delegates!
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = about_us;
function about_us(param) {
	var offset = 0;
	if (param === "rs") {
		offset = $(".about_us .rs").offset().top;
	} else if (param === "join") {
		offset = $(".about_us .join").offset().top;
	}

	if (param) {
		$('html, body').animate({
	      scrollTop: offset - 80
	    }, 500);
	}
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contact_us;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_map__ = __webpack_require__(5);

function contact_us() {
	var contactMap = document.querySelector("#contact-map"),
		mapPlace = {
			"lat": parseFloat(contactMap.getAttribute("data-place-lat"), 10),
			"lng": parseFloat(contactMap.getAttribute("data-place-lng"), 10)
		},
		mapCenter = {
			"lat": parseFloat(contactMap.getAttribute("data-center-lat"), 10),
			"lng": parseFloat(contactMap.getAttribute("data-center-lng"), 10)
		};

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_map__["a" /* default */])(contactMap.id, {
		API_KEY: contactMap.getAttribute("data-api-key"),
		place: mapPlace,
		center: window.isMobile ? mapPlace : mapCenter,
		title: contactMap.getAttribute("data-place-title")
	});

}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = home;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sameHeight__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scrollPosition__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_map__ = __webpack_require__(5);




function home() {
	var menuLinks = document.querySelectorAll(".site-menu-dropdown .action-menu-link"),
		homeMap = document.querySelector("#home-map"),
		lastActive,
		mapPlace,
		mapCenter;

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_sameHeight__["a" /* default */])(document.querySelectorAll(".home-about-us .feature-description"));

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_scrollPosition__["a" /* default */])(document.querySelectorAll(".scroll-event"), {
		offset: 2,
		callback: function (data) {
			if (data.index !== lastActive) {
				[].forEach.call(menuLinks, function(elem) {
					elem.classList.remove("active");
				});
			}
			menuLinks[data.index].classList.add("active");
			lastActive = data.index;
		}
	});

	mapPlace = {
		"lat": parseFloat(homeMap.getAttribute("data-place-lat"), 10),
		"lng": parseFloat(homeMap.getAttribute("data-place-lng"), 10)
	};

	mapCenter = {
		"lat": parseFloat(homeMap.getAttribute("data-center-lat"), 10),
		"lng": parseFloat(homeMap.getAttribute("data-center-lng"), 10)
	};

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_map__["a" /* default */])(homeMap.id, {
		API_KEY: homeMap.getAttribute("data-api-key"),
		place: mapPlace,
		center: window.isMobile || window.innerWidth <= 768 ? mapPlace : mapCenter,
		title: homeMap.getAttribute("data-place-title")
	});
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = our_services;
function main(param) {
	$(".menu span").unbind("click").on("click", function (e) {
		var isActive = $(this).hasClass("active");
		$(".menu span").not(this).removeClass("active");

		if (!isActive) {
			var thisClass = $(this).data("class");
			$("." + thisClass + " .billboard .arrow").click();
		}
	});

	$(".billboard .arrow").unbind("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var self = this;
		var isActive = $(this).hasClass("active");
		var currentHeight = 

		$(".menu span").removeClass("active");
		$(".billboard .arrow.active").removeClass("active");
		$(".services .child.active").fadeOut();
		$(".module .arrow.active").removeClass("active");
		$(".module p.active").fadeOut();

		$("p.full.active").hide().removeClass("active");
		$("p.half.active").show().removeClass("active");
		$(".billboard").clearQueue().stop();
		$(".billboard.active").animate({height: "auto"}, 500);

		if (!isActive) {
			var thisClass = $(this).data("class");
			$(this).addClass("active");
			$(".menu span." + thisClass).addClass("active");

			$(this).closest(".billboard").animate({height: "auto"}, 250, function () {
				$(self).siblings("p.half").hide().addClass("active");
				$(self).siblings("p.full").show().addClass("active");

				if ($(".child." + thisClass).length)
					$(".child." + thisClass).fadeIn().addClass("active");
			}).addClass("active");

			setTimeout(function () {
				$('html, body').animate({
			      scrollTop: $(self).offset().top - 250
			    }, 375);
			}, 500);
		
		}
	});

	$(".module .arrow").unbind("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();
		var self = this;

		var isActive = $(this).hasClass("active");
		$(".module .arrow").removeClass("active");
		$(".module p").fadeOut();

		if (!isActive) {
			var thisClass = $(this).data("class");
			$(this).addClass("active");

			$(".module p." + thisClass).fadeIn().addClass("active");
		}

		setTimeout(function () {
			$('html, body').animate({
		      scrollTop: $(self).offset().top - 250
		    }, 375);
		}, 500);
	});

	if (param) {
		document.querySelector('span.'+ param+ '[data-class="' + param + '"]').click();
	}
}

function our_services(param) {
	main(param);
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function test(param) {

}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = templates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_data_en_data_json__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_data_en_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__templates_data_en_data_json__);


const supportedLang = ['en'];
var supportedLangData = [];



//import es from '../templates/data/data-es.json';

// es importante el orden coincida con "supportedLang"
supportedLangData.push(__WEBPACK_IMPORTED_MODULE_1__templates_data_en_data_json___default.a);
//supportedLangData.push(es);

var compiled = __webpack_require__(35); //https://github.com/emaphp/handlebars-template-loader
var compiledPages = [];
// Get Handlebars instance
var Handlebars = __webpack_require__(36);

// Register partial
Handlebars.registerPartial('header', __webpack_require__(25));
Handlebars.registerPartial('footer', __webpack_require__(24));

Handlebars.registerPartial('home', __webpack_require__(30));
Handlebars.registerPartial('why_rs', __webpack_require__(34));
Handlebars.registerPartial('why_la', __webpack_require__(33));
Handlebars.registerPartial('our_services', __webpack_require__(31));
Handlebars.registerPartial('about_us', __webpack_require__(26));
Handlebars.registerPartial('candidate_appl_form', __webpack_require__(28));
Handlebars.registerPartial('investigator_appl_form', __webpack_require__(29));
Handlebars.registerPartial('contact_us', __webpack_require__(27));
Handlebars.registerPartial('test', __webpack_require__(32));

Handlebars.registerPartial('list', __webpack_require__(21));
Handlebars.registerPartial('slider', __webpack_require__(23));
Handlebars.registerPartial('map', __webpack_require__(22));
Handlebars.registerPartial('form', __webpack_require__(20));



Handlebars.registerHelper('ifCond', function(v1, v2, options) {
  if(v1 === v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerPartial('form-validation', __webpack_require__(19));
Handlebars.registerPartial('form-input', __webpack_require__(18));

function templates(lang, callback) {
	var data = compiled(supportedLangData[0]);

	document.querySelector("html").setAttribute("lang", supportedLang[0]);

	if (DEBUG) {
		if (DEBUG === "css") {
			document.querySelector("html").classList.add("debug");
		}
		data += '<div class="debug-tree"><div class="content-wrapper"><div class="border"></div></div></div>';
	}

	document.querySelector('#web-container').innerHTML = data;

	if (callback) {
		callback();
	}
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/*! hyperform.js.org */
window.hyperform = (function () {
                       'use strict';

                       var registry = Object.create(null);

                       /**
                        * run all actions registered for a hook
                        *
                        * Every action gets called with a state object as `this` argument and with the
                        * hook's call arguments as call arguments.
                        *
                        * @return mixed the returned value of the action calls or undefined
                        */
                       function call_hook(hook) {
                         var result;
                         var call_args = Array.prototype.slice.call(arguments, 1);

                         if (hook in registry) {
                           result = registry[hook].reduce(function (args) {

                             return function (previousResult, currentAction) {
                               var interimResult = currentAction.apply({
                                 state: previousResult,
                                 hook: hook
                               }, args);
                               return interimResult !== undefined ? interimResult : previousResult;
                             };
                           }(call_args), result);
                         }

                         return result;
                       }

                       /**
                        * Filter a value through hooked functions
                        *
                        * Allows for additional parameters:
                        * js> do_filter('foo', null, current_element)
                        */
                       function do_filter(hook, initial_value) {
                         var result = initial_value;
                         var call_args = Array.prototype.slice.call(arguments, 1);

                         if (hook in registry) {
                           result = registry[hook].reduce(function (previousResult, currentAction) {
                             call_args[0] = previousResult;
                             var interimResult = currentAction.apply({
                               state: previousResult,
                               hook: hook
                             }, call_args);
                             return interimResult !== undefined ? interimResult : previousResult;
                           }, result);
                         }

                         return result;
                       }

                       /**
                        * remove an action again
                        */
                       function remove_hook(hook, action) {
                         if (hook in registry) {
                           for (var i = 0; i < registry[hook].length; i++) {
                             if (registry[hook][i] === action) {
                               registry[hook].splice(i, 1);
                               break;
                             }
                           }
                         }
                       }
                       /**
                        * add an action to a hook
                        */
                       function add_hook(hook, action, position) {
                         if (!(hook in registry)) {
                           registry[hook] = [];
                         }
                         if (position === undefined) {
                           position = registry[hook].length;
                         }
                         registry[hook].splice(position, 0, action);
                       }

                       /**
                        * return either the data of a hook call or the result of action, if the
                        * former is undefined
                        *
                        * @return function a function wrapper around action
                        */
                       function return_hook_or (hook, action) {
                         return function () {
                           var data = call_hook(hook, Array.prototype.slice.call(arguments));

                           if (data !== undefined) {
                             return data;
                           }

                           return action.apply(this, arguments);
                         };
                       }

                       /* the following code is borrowed from the WebComponents project, licensed
                        * under the BSD license. Source:
                        * <https://github.com/webcomponents/webcomponentsjs/blob/5283db1459fa2323e5bfc8b9b5cc1753ed85e3d0/src/WebComponents/dom.js#L53-L78>
                        */
                       // defaultPrevented is broken in IE.
                       // https://connect.microsoft.com/IE/feedback/details/790389/event-defaultprevented-returns-false-after-preventdefault-was-called

                       var workingDefaultPrevented = function () {
                         var e = document.createEvent('Event');
                         e.initEvent('foo', true, true);
                         e.preventDefault();
                         return e.defaultPrevented;
                       }();

                       if (!workingDefaultPrevented) {
                         (function () {
                           var origPreventDefault = window.Event.prototype.preventDefault;
                           window.Event.prototype.preventDefault = function () {
                             if (!this.cancelable) {
                               return;
                             }

                             origPreventDefault.call(this);

                             Object.defineProperty(this, 'defaultPrevented', {
                               get: function get() {
                                 return true;
                               },
                               configurable: true
                             });
                           };
                         })();
                       }
                       /* end of borrowed code */

                       function create_event(name) {
                         var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                         var _ref$bubbles = _ref.bubbles;
                         var bubbles = _ref$bubbles === undefined ? true : _ref$bubbles;
                         var _ref$cancelable = _ref.cancelable;
                         var cancelable = _ref$cancelable === undefined ? false : _ref$cancelable;

                         var event = document.createEvent('Event');
                         event.initEvent(name, bubbles, cancelable);
                         return event;
                       }

                       function trigger_event (element, event) {
                         var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                         var _ref2$bubbles = _ref2.bubbles;
                         var bubbles = _ref2$bubbles === undefined ? true : _ref2$bubbles;
                         var _ref2$cancelable = _ref2.cancelable;
                         var cancelable = _ref2$cancelable === undefined ? false : _ref2$cancelable;
                         var payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

                         if (!(event instanceof window.Event)) {
                           event = create_event(event, { bubbles: bubbles, cancelable: cancelable });
                         }

                         for (var key in payload) {
                           if (payload.hasOwnProperty(key)) {
                             event[key] = payload[key];
                           }
                         }

                         element.dispatchEvent(event);

                         return event;
                       }

                       /* and datetime-local? Spec says “Nah!” */

                       var dates = ['datetime', 'date', 'month', 'week', 'time'];

                       var plain_numbers = ['number', 'range'];

                       /* everything that returns something meaningful for valueAsNumber and
                        * can have the step attribute */
                       var numbers = dates.concat(plain_numbers, 'datetime-local');

                       /* the spec says to only check those for syntax in validity.typeMismatch.
                        * ¯\_(ツ)_/¯ */
                       var type_checked = ['email', 'url'];

                       /* check these for validity.badInput */
                       var input_checked = ['email', 'date', 'month', 'week', 'time', 'datetime', 'datetime-local', 'number', 'range', 'color'];

                       var text_types = ['text', 'search', 'tel', 'password'].concat(type_checked);

                       /* input element types, that are candidates for the validation API.
                        * Missing from this set are: button, hidden, menu (from <button>), reset and
                        * the types for non-<input> elements. */
                       var validation_candidates = ['checkbox', 'color', 'file', 'image', 'radio', 'submit'].concat(numbers, text_types);

                       /* all known types of <input> */
                       var inputs = ['button', 'hidden', 'reset'].concat(validation_candidates);

                       /* apparently <select> and <textarea> have types of their own */
                       var non_inputs = ['select-one', 'select-multiple', 'textarea'];

                       /* shim layer for the Element.matches method */

                       var ep = window.Element.prototype;
                       var native_matches = ep.matches || ep.matchesSelector || ep.msMatchesSelector || ep.webkitMatchesSelector;

                       function matches (element, selector) {
                                              return native_matches.call(element, selector);
                       }

                       /**
                        * mark an object with a '__hyperform=true' property
                        *
                        * We use this to distinguish our properties from the native ones. Usage:
                        * js> mark(obj);
                        * js> assert(obj.__hyperform === true)
                        */

                       function mark (obj) {
                         if (['object', 'function'].indexOf(typeof obj) > -1) {
                           delete obj.__hyperform;
                           Object.defineProperty(obj, '__hyperform', {
                             configurable: true,
                             enumerable: false,
                             value: true
                           });
                         }

                         return obj;
                       }

                       /**
                        * the internal storage for messages
                        */
                       var store = new WeakMap();

                       /* jshint -W053 */ /* allow new String() */
                       /**
                        * handle validation messages
                        *
                        * Falls back to browser-native errors, if any are available. The messages
                        * are String objects so that we can mark() them.
                        */
                       var message_store = {
                         set: function set(element, message) {
                           var is_custom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                           if (element instanceof window.HTMLFieldSetElement) {
                             var wrapped_form = get_wrapper(element);
                             if (wrapped_form && !wrapped_form.settings.extendFieldset) {
                               /* make this a no-op for <fieldset> in strict mode */
                               return message_store;
                             }
                           }

                           if (typeof message === 'string') {
                             message = new String(message);
                           }
                           if (is_custom) {
                             message.is_custom = true;
                           }
                           mark(message);
                           store.set(element, message);

                           /* allow the :invalid selector to match */
                           if ('_original_setCustomValidity' in element) {
                             element._original_setCustomValidity(message.toString());
                           }

                           return message_store;
                         },
                         get: function get(element) {
                           var message = store.get(element);
                           if (message === undefined && '_original_validationMessage' in element) {
                             /* get the browser's validation message, if we have none. Maybe it
                              * knows more than we. */
                             message = new String(element._original_validationMessage);
                           }
                           return message ? message : new String('');
                         },
                         delete: function _delete(element) {
                           if ('_original_setCustomValidity' in element) {
                             element._original_setCustomValidity('');
                           }
                           return store.delete(element);
                         }
                       };

                       /**
                        * counter that will be incremented with every call
                        *
                        * Will enforce uniqueness, as long as no more than 1 hyperform scripts
                        * are loaded. (In that case we still have the "random" part below.)
                        */

                       var uid = 0;

                       /**
                        * generate a random ID
                        *
                        * @see https://gist.github.com/gordonbrander/2230317
                        */
                       function generate_id () {
                         var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hf_';

                         return prefix + uid++ + Math.random().toString(36).substr(2);
                       }

                       var warningsCache = new WeakMap();

                       var DefaultRenderer = {

                         /**
                          * called when a warning should become visible
                          */
                         attachWarning: function attachWarning(warning, element) {
                           /* should also work, if element is last,
                            * http://stackoverflow.com/a/4793630/113195 */
                           element.parentNode.insertBefore(warning, element.nextSibling);
                         },

                         /**
                          * called when a warning should vanish
                          */
                         detachWarning: function detachWarning(warning, element) {
                           /* be conservative here, since an overwritten attachWarning() might not
                            * actually have attached the warning. */
                           if (warning.parentNode) {
                             warning.parentNode.removeChild(warning);
                           }
                         },

                         /**
                          * called when feedback to an element's state should be handled
                          *
                          * i.e., showing and hiding warnings
                          */
                         showWarning: function showWarning(element) {
                           var sub_radio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                           var msg = message_store.get(element).toString();
                           var warning = warningsCache.get(element);

                           if (msg) {
                             if (!warning) {
                               var wrapper = get_wrapper(element);
                               warning = document.createElement('div');
                               warning.className = wrapper && wrapper.settings.classes.warning || 'hf-warning';
                               warning.id = generate_id();
                               warning.setAttribute('aria-live', 'polite');
                               warningsCache.set(element, warning);
                             }

                             element.setAttribute('aria-errormessage', warning.id);
                             if (!element.hasAttribute('aria-describedby')) {
                               element.setAttribute('aria-describedby', warning.id);
                             }
                             warning.textContent = msg;
                             Renderer.attachWarning(warning, element);
                           } else if (warning && warning.parentNode) {
                             if (element.getAttribute('aria-describedby') === warning.id) {
                               element.removeAttribute('aria-describedby');
                             }
                             element.removeAttribute('aria-errormessage');
                             Renderer.detachWarning(warning, element);
                           }

                           if (!sub_radio && element.type === 'radio' && element.form) {
                             /* render warnings for all other same-name radios, too */
                             Array.prototype.filter.call(document.getElementsByName(element.name), function (radio) {
                               return radio.name === element.name && radio.form === element.form;
                             }).map(function (radio) {
                               return Renderer.showWarning(radio, 'sub_radio');
                             });
                           }
                         }

                       };

                       var Renderer = {

                         attachWarning: DefaultRenderer.attachWarning,
                         detachWarning: DefaultRenderer.detachWarning,
                         showWarning: DefaultRenderer.showWarning,

                         set: function set(renderer, action) {
                           if (renderer.indexOf('_') > -1) {
                             /* global console */
                             // TODO delete before next non-patch version
                             console.log('Renderer.set: please use camelCase names. ' + renderer + ' will be removed in the next non-patch release.');
                             renderer = renderer.replace(/_([a-z])/g, function (g) {
                               return g[1].toUpperCase();
                             });
                           }
                           if (!action) {
                             action = DefaultRenderer[renderer];
                           }
                           Renderer[renderer] = action;
                         }

                       };

                       /**
                        * check element's validity and report an error back to the user
                        */
                       function reportValidity(element) {
                         /* if this is a <form>, report validity of all child inputs */
                         if (element instanceof window.HTMLFormElement) {
                           return Array.prototype.map.call(element.elements, reportValidity).every(function (b) {
                             return b;
                           });
                         }

                         /* we copy checkValidity() here, b/c we have to check if the "invalid"
                          * event was canceled. */
                         var valid = ValidityState(element).valid;
                         var event;
                         if (valid) {
                           var wrapped_form = get_wrapper(element);
                           if (wrapped_form && wrapped_form.settings.validEvent) {
                             event = trigger_event(element, 'valid', { cancelable: true });
                           }
                         } else {
                           event = trigger_event(element, 'invalid', { cancelable: true });
                         }

                         if (!event || !event.defaultPrevented) {
                           Renderer.showWarning(element);
                         }

                         return valid;
                       }

                       /**
                        * submit a form, because `element` triggered it
                        *
                        * This method also dispatches a submit event on the form prior to the
                        * submission. The event contains the trigger element as `submittedVia`.
                        *
                        * If the element is a button with a name, the name=value pair will be added
                        * to the submitted data.
                        */
                       function submit_form_via(element) {
                         /* apparently, the submit event is not triggered in most browsers on
                          * the submit() method, so we do it manually here to model a natural
                          * submit as closely as possible.
                          * Now to the fun fact: If you trigger a submit event from a form, what
                          * do you think should happen?
                          * 1) the form will be automagically submitted by the browser, or
                          * 2) nothing.
                          * And as you already suspected, the correct answer is: both! Firefox
                          * opts for 1), Chrome for 2). Yay! */
                         var event_got_cancelled;

                         var submit_event = create_event('submit', { cancelable: true });
                         /* force Firefox to not submit the form, then fake preventDefault() */
                         submit_event.preventDefault();
                         Object.defineProperty(submit_event, 'defaultPrevented', {
                           value: false,
                           writable: true
                         });
                         Object.defineProperty(submit_event, 'preventDefault', {
                           value: function value() {
                             return submit_event.defaultPrevented = event_got_cancelled = true;
                           },
                           writable: true
                         });
                         trigger_event(element.form, submit_event, {}, { submittedVia: element });

                         if (!event_got_cancelled) {
                           add_submit_field(element);
                           window.HTMLFormElement.prototype.submit.call(element.form);
                           window.setTimeout(function () {
                             return remove_submit_field(element);
                           });
                         }
                       }

                       /**
                        * if a submit button was clicked, add its name=value by means of a type=hidden
                        * input field
                        */
                       function add_submit_field(button) {
                         if (['image', 'submit'].indexOf(button.type) > -1 && button.name) {
                           var wrapper = get_wrapper(button.form) || {};
                           var submit_helper = wrapper.submit_helper;
                           if (submit_helper) {
                             if (submit_helper.parentNode) {
                               submit_helper.parentNode.removeChild(submit_helper);
                             }
                           } else {
                             submit_helper = document.createElement('input');
                             submit_helper.type = 'hidden';
                             wrapper.submit_helper = submit_helper;
                           }
                           submit_helper.name = button.name;
                           submit_helper.value = button.value;
                           button.form.appendChild(submit_helper);
                         }
                       }

                       /**
                        * remove a possible helper input, that was added by `add_submit_field`
                        */
                       function remove_submit_field(button) {
                         if (['image', 'submit'].indexOf(button.type) > -1 && button.name) {
                           var wrapper = get_wrapper(button.form) || {};
                           var submit_helper = wrapper.submit_helper;
                           if (submit_helper && submit_helper.parentNode) {
                             submit_helper.parentNode.removeChild(submit_helper);
                           }
                         }
                       }

                       /**
                        * check a form's validity and submit it
                        *
                        * The method triggers a cancellable `validate` event on the form. If the
                        * event is cancelled, form submission will be aborted, too.
                        *
                        * If the form is found to contain invalid fields, focus the first field.
                        */
                       function check(button) {
                         /* trigger a "validate" event on the form to be submitted */
                         var val_event = trigger_event(button.form, 'validate', { cancelable: true });
                         if (val_event.defaultPrevented) {
                           /* skip the whole submit thing, if the validation is canceled. A user
                            * can still call form.submit() afterwards. */
                           return;
                         }

                         var valid = true;
                         var first_invalid;
                         Array.prototype.map.call(button.form.elements, function (element) {
                           if (!reportValidity(element)) {
                             valid = false;
                             if (!first_invalid && 'focus' in element) {
                               first_invalid = element;
                             }
                           }
                         });

                         if (valid) {
                           submit_form_via(button);
                         } else if (first_invalid) {
                           /* focus the first invalid element, if validation went south */
                           first_invalid.focus();
                           /* tell the tale, if anyone wants to react to it */
                           trigger_event(button.form, 'forminvalid');
                         }
                       }

                       /**
                        * test if node is a submit button
                        */
                       function is_submit_button(node) {
                         return (
                           /* must be an input or button element... */
                           (node.nodeName === 'INPUT' || node.nodeName === 'BUTTON') && (

                           /* ...and have a submitting type */
                           node.type === 'image' || node.type === 'submit')
                         );
                       }

                       /**
                        * test, if the click event would trigger a submit
                        */
                       function is_submitting_click(event, button) {
                         return (
                           /* prevented default: won't trigger a submit */
                           !event.defaultPrevented && (

                           /* left button or middle button (submits in Chrome) */
                           !('button' in event) || event.button < 2) &&

                           /* must be a submit button... */
                           is_submit_button(button) &&

                           /* the button needs a form, that's going to be submitted */
                           button.form &&

                           /* again, if the form should not be validated, we're out of the game */
                           !button.form.hasAttribute('novalidate')
                         );
                       }

                       /**
                        * test, if the keypress event would trigger a submit
                        */
                       function is_submitting_keypress(event) {
                         return (
                           /* prevented default: won't trigger a submit */
                           !event.defaultPrevented && (
                           /* ...and <Enter> was pressed... */
                           event.keyCode === 13 &&

                           /* ...on an <input> that is... */
                           event.target.nodeName === 'INPUT' &&

                           /* ...a standard text input field (not checkbox, ...) */
                           text_types.indexOf(event.target.type) > -1 ||
                           /* or <Enter> or <Space> was pressed... */
                           (event.keyCode === 13 || event.keyCode === 32) &&

                           /* ...on a submit button */
                           is_submit_button(event.target)) &&

                           /* there's a form... */
                           event.target.form &&

                           /* ...and the form allows validation */
                           !event.target.form.hasAttribute('novalidate')
                         );
                       }

                       /**
                        * catch clicks to children of <button>s
                        */
                       function get_clicked_button(element) {
                         if (is_submit_button(element)) {
                           return element;
                         } else if (matches(element, 'button:not([type]) *, button[type="submit"] *')) {
                           return get_clicked_button(element.parentNode);
                         } else {
                           return null;
                         }
                       }

                       /**
                        * return event handler to catch explicit submission by click on a button
                        */
                       function get_click_handler() {
                         var ignore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                         return function (event) {
                           var button = get_clicked_button(event.target);
                           if (button && is_submitting_click(event, button)) {
                             event.preventDefault();
                             if (ignore || button.hasAttribute('formnovalidate')) {
                               /* if validation should be ignored, we're not interested in any checks */
                               submit_form_via(button);
                             } else {
                               check(button);
                             }
                           }
                         };
                       }
                       var click_handler = get_click_handler();
                       var ignored_click_handler = get_click_handler(true);

                       /**
                        * catch implicit submission by pressing <Enter> in some situations
                        */
                       function get_keypress_handler(ignore) {
                         return function keypress_handler(event) {
                           if (is_submitting_keypress(event)) {
                             event.preventDefault();

                             var wrapper = get_wrapper(event.target.form) || { settings: {} };
                             if (wrapper.settings.preventImplicitSubmit) {
                               /* user doesn't want an implicit submit. Cancel here. */
                               return;
                             }

                             /* check, that there is no submit button in the form. Otherwise
                             * that should be clicked. */
                             var el = event.target.form.elements.length;
                             var submit;
                             for (var i = 0; i < el; i++) {
                               if (['image', 'submit'].indexOf(event.target.form.elements[i].type) > -1) {
                                 submit = event.target.form.elements[i];
                                 break;
                               }
                             }

                             if (submit) {
                               submit.click();
                             } else if (ignore) {
                               submit_form_via(event.target);
                             } else {
                               check(event.target);
                             }
                           }
                         };
                       }
                       var keypress_handler = get_keypress_handler();
                       var ignored_keypress_handler = get_keypress_handler(true);

                       /**
                        * catch all relevant events _prior_ to a form being submitted
                        *
                        * @param bool ignore bypass validation, when an attempt to submit the
                        *                    form is detected. True, when the wrapper's revalidate
                        *                    setting is 'never'.
                        */
                       function catch_submit(listening_node) {
                         var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                         if (ignore) {
                           listening_node.addEventListener('click', ignored_click_handler);
                           listening_node.addEventListener('keypress', ignored_keypress_handler);
                         } else {
                           listening_node.addEventListener('click', click_handler);
                           listening_node.addEventListener('keypress', keypress_handler);
                         }
                       }

                       /**
                        * decommission the event listeners from catch_submit() again
                        */
                       function uncatch_submit(listening_node) {
                         listening_node.removeEventListener('click', ignored_click_handler);
                         listening_node.removeEventListener('keypress', ignored_keypress_handler);
                         listening_node.removeEventListener('click', click_handler);
                         listening_node.removeEventListener('keypress', keypress_handler);
                       }

                       /**
                        * remove `property` from element and restore _original_property, if present
                        */
                       function uninstall_property (element, property) {
                         try {
                           delete element[property];
                         } catch (e) {
                           /* Safari <= 9 and PhantomJS will end up here :-( Nothing to do except
                            * warning */
                           var wrapper = get_wrapper(element);
                           if (wrapper && wrapper.settings.debug) {
                             /* global console */
                             console.log('[hyperform] cannot uninstall custom property ' + property);
                           }
                           return false;
                         }

                         var original_descriptor = Object.getOwnPropertyDescriptor(element, '_original_' + property);

                         if (original_descriptor) {
                           Object.defineProperty(element, property, original_descriptor);
                         }
                       }

                       /**
                        * add `property` to an element
                        *
                        * js> installer(element, 'foo', { value: 'bar' });
                        * js> assert(element.foo === 'bar');
                        */
                       function install_property (element, property, descriptor) {
                         descriptor.configurable = true;
                         descriptor.enumerable = true;
                         if ('value' in descriptor) {
                           descriptor.writable = true;
                         }

                         var original_descriptor = Object.getOwnPropertyDescriptor(element, property);

                         if (original_descriptor) {

                           if (original_descriptor.configurable === false) {
                             /* Safari <= 9 and PhantomJS will end up here :-( Nothing to do except
                              * warning */
                             var wrapper = get_wrapper(element);
                             if (wrapper && wrapper.settings.debug) {
                               /* global console */
                               console.log('[hyperform] cannot install custom property ' + property);
                             }
                             return false;
                           }

                           /* we already installed that property... */
                           if (original_descriptor.get && original_descriptor.get.__hyperform || original_descriptor.value && original_descriptor.value.__hyperform) {
                             return;
                           }

                           /* publish existing property under new name, if it's not from us */
                           Object.defineProperty(element, '_original_' + property, original_descriptor);
                         }

                         delete element[property];
                         Object.defineProperty(element, property, descriptor);

                         return true;
                       }

                       function is_field (element) {
                               return element instanceof window.HTMLButtonElement || element instanceof window.HTMLInputElement || element instanceof window.HTMLSelectElement || element instanceof window.HTMLTextAreaElement || element instanceof window.HTMLFieldSetElement || element === window.HTMLButtonElement.prototype || element === window.HTMLInputElement.prototype || element === window.HTMLSelectElement.prototype || element === window.HTMLTextAreaElement.prototype || element === window.HTMLFieldSetElement.prototype;
                       }

                       /**
                        * set a custom validity message or delete it with an empty string
                        */
                       function setCustomValidity(element, msg) {
                         message_store.set(element, msg, true);
                       }

                       function sprintf (str) {
                         for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                           args[_key - 1] = arguments[_key];
                         }

                         var args_length = args.length;
                         var global_index = 0;

                         return str.replace(/%([0-9]+\$)?([sl])/g, function (match, position, type) {
                           var local_index = global_index;
                           if (position) {
                             local_index = Number(position.replace(/\$$/, '')) - 1;
                           }
                           global_index += 1;

                           var arg = '';
                           if (args_length > local_index) {
                             arg = args[local_index];
                           }

                           if (arg instanceof Date || typeof arg === 'number' || arg instanceof Number) {
                             /* try getting a localized representation of dates and numbers, if the
                              * browser supports this */
                             if (type === 'l') {
                               arg = (arg.toLocaleString || arg.toString).call(arg);
                             } else {
                               arg = arg.toString();
                             }
                           }

                           return arg;
                         });
                       }

                       /* For a given date, get the ISO week number
                        *
                        * Source: http://stackoverflow.com/a/6117889/113195
                        *
                        * Based on information at:
                        *
                        *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR
                        *
                        * Algorithm is to find nearest thursday, it's year
                        * is the year of the week number. Then get weeks
                        * between that date and the first day of that year.
                        *
                        * Note that dates in one year can be weeks of previous
                        * or next year, overlap is up to 3 days.
                        *
                        * e.g. 2014/12/29 is Monday in week  1 of 2015
                        *      2012/1/1   is Sunday in week 52 of 2011
                        */

                       function get_week_of_year (d) {
                         /* Copy date so don't modify original */
                         d = new Date(+d);
                         d.setUTCHours(0, 0, 0);
                         /* Set to nearest Thursday: current date + 4 - current day number
                          * Make Sunday's day number 7 */
                         d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
                         /* Get first day of year */
                         var yearStart = new Date(d.getUTCFullYear(), 0, 1);
                         /* Calculate full weeks to nearest Thursday */
                         var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
                         /* Return array of year and week number */
                         return [d.getUTCFullYear(), weekNo];
                       }

                       function pad(num) {
                         var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

                         var s = num + '';
                         while (s.length < size) {
                           s = '0' + s;
                         }
                         return s;
                       }

                       /**
                        * calculate a string from a date according to HTML5
                        */
                       function date_to_string(date, element_type) {
                         if (!(date instanceof Date)) {
                           return null;
                         }

                         switch (element_type) {
                           case 'datetime':
                             return date_to_string(date, 'date') + 'T' + date_to_string(date, 'time');

                           case 'datetime-local':
                             return sprintf('%s-%s-%sT%s:%s:%s.%s', date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate()), pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds()), pad(date.getMilliseconds(), 3)).replace(/(:00)?\.000$/, '');

                           case 'date':
                             return sprintf('%s-%s-%s', date.getUTCFullYear(), pad(date.getUTCMonth() + 1), pad(date.getUTCDate()));

                           case 'month':
                             return sprintf('%s-%s', date.getUTCFullYear(), pad(date.getUTCMonth() + 1));

                           case 'week':
                             var params = get_week_of_year(date);
                             return sprintf.call(null, '%s-W%s', params[0], pad(params[1]));

                           case 'time':
                             return sprintf('%s:%s:%s.%s', pad(date.getUTCHours()), pad(date.getUTCMinutes()), pad(date.getUTCSeconds()), pad(date.getUTCMilliseconds(), 3)).replace(/(:00)?\.000$/, '');
                         }

                         return null;
                       }

                       /**
                        * return a new Date() representing the ISO date for a week number
                        *
                        * @see http://stackoverflow.com/a/16591175/113195
                        */

                       function get_date_from_week (week, year) {
                         var date = new Date(Date.UTC(year, 0, 1 + (week - 1) * 7));

                         if (date.getUTCDay() <= 4 /* thursday */) {
                             date.setUTCDate(date.getUTCDate() - date.getUTCDay() + 1);
                           } else {
                           date.setUTCDate(date.getUTCDate() + 8 - date.getUTCDay());
                         }

                         return date;
                       }

                       /**
                        * calculate a date from a string according to HTML5
                        */
                       function string_to_date (string, element_type) {
                         var date = new Date(0);
                         var ms;
                         switch (element_type) {
                           case 'datetime':
                             if (!/^([0-9]{4,})-([0-9]{2})-([0-9]{2})T([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\.([0-9]{1,3}))?)?$/.test(string)) {
                               return null;
                             }
                             ms = RegExp.$7 || '000';
                             while (ms.length < 3) {
                               ms += '0';
                             }
                             date.setUTCFullYear(Number(RegExp.$1));
                             date.setUTCMonth(Number(RegExp.$2) - 1, Number(RegExp.$3));
                             date.setUTCHours(Number(RegExp.$4), Number(RegExp.$5), Number(RegExp.$6 || 0), Number(ms));
                             return date;

                           case 'date':
                             if (!/^([0-9]{4,})-([0-9]{2})-([0-9]{2})$/.test(string)) {
                               return null;
                             }
                             date.setUTCFullYear(Number(RegExp.$1));
                             date.setUTCMonth(Number(RegExp.$2) - 1, Number(RegExp.$3));
                             return date;

                           case 'month':
                             if (!/^([0-9]{4,})-([0-9]{2})$/.test(string)) {
                               return null;
                             }
                             date.setUTCFullYear(Number(RegExp.$1));
                             date.setUTCMonth(Number(RegExp.$2) - 1, 1);
                             return date;

                           case 'week':
                             if (!/^([0-9]{4,})-W(0[1-9]|[1234][0-9]|5[0-3])$/.test(string)) {
                               return null;
                             }
                             return get_date_from_week(Number(RegExp.$2), Number(RegExp.$1));

                           case 'time':
                             if (!/^([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\.([0-9]{1,3}))?)?$/.test(string)) {
                               return null;
                             }
                             ms = RegExp.$4 || '000';
                             while (ms.length < 3) {
                               ms += '0';
                             }
                             date.setUTCHours(Number(RegExp.$1), Number(RegExp.$2), Number(RegExp.$3 || 0), Number(ms));
                             return date;
                         }

                         return null;
                       }

                       /**
                        * calculate a date from a string according to HTML5
                        */
                       function string_to_number (string, element_type) {
                         var rval = string_to_date(string, element_type);
                         if (rval !== null) {
                           return +rval;
                         }
                         /* not parseFloat, because we want NaN for invalid values like "1.2xxy" */
                         return Number(string);
                       }

                       /**
                        * get the element's type in a backwards-compatible way
                        */
                       function get_type (element) {
                         if (element instanceof window.HTMLTextAreaElement) {
                           return 'textarea';
                         } else if (element instanceof window.HTMLSelectElement) {
                           return element.hasAttribute('multiple') ? 'select-multiple' : 'select-one';
                         } else if (element instanceof window.HTMLButtonElement) {
                           return (element.getAttribute('type') || 'submit').toLowerCase();
                         } else if (element instanceof window.HTMLInputElement) {
                           var attr = (element.getAttribute('type') || '').toLowerCase();
                           if (attr && inputs.indexOf(attr) > -1) {
                             return attr;
                           } else {
                             /* perhaps the DOM has in-depth knowledge. Take that before returning
                              * 'text'. */
                             return element.type || 'text';
                           }
                         }

                         return '';
                       }

                       /**
                        * the following validation messages are from Firefox source,
                        * http://mxr.mozilla.org/mozilla-central/source/dom/locales/en-US/chrome/dom/dom.properties
                        * released under MPL license, http://mozilla.org/MPL/2.0/.
                        */

                       var catalog = {
                         en: {
                           TextTooLong: 'Please shorten this text to %l characters or less (you are currently using %l characters).',
                           ValueMissing: 'Please fill out this field.',
                           CheckboxMissing: 'Please check this box if you want to proceed.',
                           RadioMissing: 'Please select one of these options.',
                           FileMissing: 'Please select a file.',
                           SelectMissing: 'Please select an item in the list.',
                           InvalidEmail: 'Please enter an email address.',
                           InvalidURL: 'Please enter a URL.',
                           PatternMismatch: 'Please match the requested format.',
                           PatternMismatchWithTitle: 'Please match the requested format: %l.',
                           NumberRangeOverflow: 'Please select a value that is no more than %l.',
                           DateRangeOverflow: 'Please select a value that is no later than %l.',
                           TimeRangeOverflow: 'Please select a value that is no later than %l.',
                           NumberRangeUnderflow: 'Please select a value that is no less than %l.',
                           DateRangeUnderflow: 'Please select a value that is no earlier than %l.',
                           TimeRangeUnderflow: 'Please select a value that is no earlier than %l.',
                           StepMismatch: 'Please select a valid value. The two nearest valid values are %l and %l.',
                           StepMismatchOneValue: 'Please select a valid value. The nearest valid value is %l.',
                           BadInputNumber: 'Please enter a number.'
                         }
                       };

                       /**
                        * the global language Hyperform will use
                        */
                       var language = 'en';

                       /**
                        * the base language according to BCP47, i.e., only the piece before the first hyphen
                        */
                       var base_lang = 'en';

                       /**
                        * set the language for Hyperform’s messages
                        */
                       function set_language(newlang) {
                         language = newlang;
                         base_lang = newlang.replace(/[-_].*/, '');
                       }

                       /**
                        * add a lookup catalog "string: translation" for a language
                        */
                       function add_translation(lang, new_catalog) {
                         if (!(lang in catalog)) {
                           catalog[lang] = {};
                         }
                         for (var key in new_catalog) {
                           if (new_catalog.hasOwnProperty(key)) {
                             catalog[lang][key] = new_catalog[key];
                           }
                         }
                       }

                       /**
                        * return `s` translated into the current language
                        *
                        * Defaults to the base language and then English if the former has no
                        * translation for `s`.
                        */
                       function _ (s) {
                         if (language in catalog && s in catalog[language]) {
                           return catalog[language][s];
                         } else if (base_lang in catalog && s in catalog[base_lang]) {
                           return catalog[base_lang][s];
                         } else if (s in catalog.en) {
                           return catalog.en[s];
                         }
                         return s;
                       }

                       var default_step = {
                         'datetime-local': 60,
                         datetime: 60,
                         time: 60
                       };

                       var step_scale_factor = {
                         'datetime-local': 1000,
                         datetime: 1000,
                         date: 86400000,
                         week: 604800000,
                         time: 1000
                       };

                       var default_step_base = {
                         week: -259200000
                       };

                       var default_min = {
                         range: 0
                       };

                       var default_max = {
                         range: 100
                       };

                       /**
                        * get previous and next valid values for a stepped input element
                        */
                       function get_next_valid (element) {
                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

                         var type = get_type(element);

                         var aMin = element.getAttribute('min');
                         var min = default_min[type] || NaN;
                         if (aMin) {
                           var pMin = string_to_number(aMin, type);
                           if (!isNaN(pMin)) {
                             min = pMin;
                           }
                         }

                         var aMax = element.getAttribute('max');
                         var max = default_max[type] || NaN;
                         if (aMax) {
                           var pMax = string_to_number(aMax, type);
                           if (!isNaN(pMax)) {
                             max = pMax;
                           }
                         }

                         var aStep = element.getAttribute('step');
                         var step = default_step[type] || 1;
                         if (aStep && aStep.toLowerCase() === 'any') {
                           /* quick return: we cannot calculate prev and next */
                           return [_('any value'), _('any value')];
                         } else if (aStep) {
                           var pStep = string_to_number(aStep, type);
                           if (!isNaN(pStep)) {
                             step = pStep;
                           }
                         }

                         var default_value = string_to_number(element.getAttribute('value'), type);

                         var value = string_to_number(element.value || element.getAttribute('value'), type);

                         if (isNaN(value)) {
                           /* quick return: we cannot calculate without a solid base */
                           return [_('any valid value'), _('any valid value')];
                         }

                         var step_base = !isNaN(min) ? min : !isNaN(default_value) ? default_value : default_step_base[type] || 0;

                         var scale = step_scale_factor[type] || 1;

                         var prev = step_base + Math.floor((value - step_base) / (step * scale)) * (step * scale) * n;
                         var next = step_base + (Math.floor((value - step_base) / (step * scale)) + 1) * (step * scale) * n;

                         if (prev < min) {
                           prev = null;
                         } else if (prev > max) {
                           prev = max;
                         }

                         if (next > max) {
                           next = null;
                         } else if (next < min) {
                           next = min;
                         }

                         /* convert to date objects, if appropriate */
                         if (dates.indexOf(type) > -1) {
                           prev = date_to_string(new Date(prev), type);
                           next = date_to_string(new Date(next), type);
                         }

                         return [prev, next];
                       }

                       /**
                        * implement the valueAsDate functionality
                        *
                        * @see https://html.spec.whatwg.org/multipage/forms.html#dom-input-valueasdate
                        */
                       function valueAsDate(element) {
                         var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

                         var type = get_type(element);
                         if (dates.indexOf(type) > -1) {
                           if (value !== undefined) {
                             /* setter: value must be null or a Date() */
                             if (value === null) {
                               element.value = '';
                             } else if (value instanceof Date) {
                               if (isNaN(value.getTime())) {
                                 element.value = '';
                               } else {
                                 element.value = date_to_string(value, type);
                               }
                             } else {
                               throw new window.DOMException('valueAsDate setter encountered invalid value', 'TypeError');
                             }
                             return;
                           }

                           var value_date = string_to_date(element.value, type);
                           return value_date instanceof Date ? value_date : null;
                         } else if (value !== undefined) {
                           /* trying to set a date on a not-date input fails */
                           throw new window.DOMException('valueAsDate setter cannot set date on this element', 'InvalidStateError');
                         }

                         return null;
                       }

                       /**
                        * implement the valueAsNumber functionality
                        *
                        * @see https://html.spec.whatwg.org/multipage/forms.html#dom-input-valueasnumber
                        */
                       function valueAsNumber(element) {
                         var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

                         var type = get_type(element);
                         if (numbers.indexOf(type) > -1) {
                           if (type === 'range' && element.hasAttribute('multiple')) {
                             /* @see https://html.spec.whatwg.org/multipage/forms.html#do-not-apply */
                             return NaN;
                           }

                           if (value !== undefined) {
                             /* setter: value must be NaN or a finite number */
                             if (isNaN(value)) {
                               element.value = '';
                             } else if (typeof value === 'number' && window.isFinite(value)) {
                               try {
                                 /* try setting as a date, but... */
                                 valueAsDate(element, new Date(value));
                               } catch (e) {
                                 /* ... when valueAsDate is not responsible, ... */
                                 if (!(e instanceof window.DOMException)) {
                                   throw e;
                                 }
                                 /* ... set it via Number.toString(). */
                                 element.value = value.toString();
                               }
                             } else {
                               throw new window.DOMException('valueAsNumber setter encountered invalid value', 'TypeError');
                             }
                             return;
                           }

                           return string_to_number(element.value, type);
                         } else if (value !== undefined) {
                           /* trying to set a number on a not-number input fails */
                           throw new window.DOMException('valueAsNumber setter cannot set number on this element', 'InvalidStateError');
                         }

                         return NaN;
                       }

                       /**
                        *
                        */
                       function stepDown(element) {
                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

                         if (numbers.indexOf(get_type(element)) === -1) {
                           throw new window.DOMException('stepDown encountered invalid type', 'InvalidStateError');
                         }
                         if ((element.getAttribute('step') || '').toLowerCase() === 'any') {
                           throw new window.DOMException('stepDown encountered step "any"', 'InvalidStateError');
                         }

                         var prev = get_next_valid(element, n)[0];

                         if (prev !== null) {
                           valueAsNumber(element, prev);
                         }
                       }

                       /**
                        *
                        */
                       function stepUp(element) {
                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

                         if (numbers.indexOf(get_type(element)) === -1) {
                           throw new window.DOMException('stepUp encountered invalid type', 'InvalidStateError');
                         }
                         if ((element.getAttribute('step') || '').toLowerCase() === 'any') {
                           throw new window.DOMException('stepUp encountered step "any"', 'InvalidStateError');
                         }

                         var next = get_next_valid(element, n)[1];

                         if (next !== null) {
                           valueAsNumber(element, next);
                         }
                       }

                       /**
                        * get the validation message for an element, empty string, if the element
                        * satisfies all constraints.
                        */
                       function validationMessage(element) {
                         var msg = message_store.get(element);
                         if (!msg) {
                           return '';
                         }

                         /* make it a primitive again, since message_store returns String(). */
                         return msg.toString();
                       }

                       /**
                        * check, if an element will be subject to HTML5 validation at all
                        */
                       function willValidate(element) {
                         return is_validation_candidate(element);
                       }

                       var gA = function gA(prop) {
                         return function () {
                           return do_filter('attr_get_' + prop, this.getAttribute(prop), this);
                         };
                       };

                       var sA = function sA(prop) {
                         return function (value) {
                           this.setAttribute(prop, do_filter('attr_set_' + prop, value, this));
                         };
                       };

                       var gAb = function gAb(prop) {
                         return function () {
                           return do_filter('attr_get_' + prop, this.hasAttribute(prop), this);
                         };
                       };

                       var sAb = function sAb(prop) {
                         return function (value) {
                           if (do_filter('attr_set_' + prop, value, this)) {
                             this.setAttribute(prop, prop);
                           } else {
                             this.removeAttribute(prop);
                           }
                         };
                       };

                       var gAn = function gAn(prop) {
                         return function () {
                           return do_filter('attr_get_' + prop, Math.max(0, Number(this.getAttribute(prop))), this);
                         };
                       };

                       var sAn = function sAn(prop) {
                         return function (value) {
                           value = do_filter('attr_set_' + prop, value, this);
                           if (/^[0-9]+$/.test(value)) {
                             this.setAttribute(prop, value);
                           }
                         };
                       };

                       function install_properties(element) {
                         var _arr = ['accept', 'max', 'min', 'pattern', 'placeholder', 'step'];

                         for (var _i = 0; _i < _arr.length; _i++) {
                           var prop = _arr[_i];
                           install_property(element, prop, {
                             get: gA(prop),
                             set: sA(prop)
                           });
                         }

                         var _arr2 = ['multiple', 'required', 'readOnly'];
                         for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
                           var _prop = _arr2[_i2];
                           install_property(element, _prop, {
                             get: gAb(_prop.toLowerCase()),
                             set: sAb(_prop.toLowerCase())
                           });
                         }

                         var _arr3 = ['minLength', 'maxLength'];
                         for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
                           var _prop2 = _arr3[_i3];
                           install_property(element, _prop2, {
                             get: gAn(_prop2.toLowerCase()),
                             set: sAn(_prop2.toLowerCase())
                           });
                         }
                       }

                       function uninstall_properties(element) {
                         var _arr4 = ['accept', 'max', 'min', 'pattern', 'placeholder', 'step', 'multiple', 'required', 'readOnly', 'minLength', 'maxLength'];

                         for (var _i4 = 0; _i4 < _arr4.length; _i4++) {
                           var prop = _arr4[_i4];
                           uninstall_property(element, prop);
                         }
                       }

                       var polyfills = {
                         checkValidity: {
                           value: mark(function () {
                             return checkValidity(this);
                           })
                         },
                         reportValidity: {
                           value: mark(function () {
                             return reportValidity(this);
                           })
                         },
                         setCustomValidity: {
                           value: mark(function (msg) {
                             return setCustomValidity(this, msg);
                           })
                         },
                         stepDown: {
                           value: mark(function () {
                             var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                             return stepDown(this, n);
                           })
                         },
                         stepUp: {
                           value: mark(function () {
                             var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                             return stepUp(this, n);
                           })
                         },
                         validationMessage: {
                           get: mark(function () {
                             return validationMessage(this);
                           })
                         },
                         validity: {
                           get: mark(function () {
                             return ValidityState(this);
                           })
                         },
                         valueAsDate: {
                           get: mark(function () {
                             return valueAsDate(this);
                           }),
                           set: mark(function (value) {
                             valueAsDate(this, value);
                           })
                         },
                         valueAsNumber: {
                           get: mark(function () {
                             return valueAsNumber(this);
                           }),
                           set: mark(function (value) {
                             valueAsNumber(this, value);
                           })
                         },
                         willValidate: {
                           get: mark(function () {
                             return willValidate(this);
                           })
                         }
                       };

                       function polyfill (element) {
                         if (is_field(element)) {

                           for (var prop in polyfills) {
                             install_property(element, prop, polyfills[prop]);
                           }

                           install_properties(element);
                         } else if (element instanceof window.HTMLFormElement || element === window.HTMLFormElement.prototype) {
                           install_property(element, 'checkValidity', polyfills.checkValidity);
                           install_property(element, 'reportValidity', polyfills.reportValidity);
                         }
                       }

                       function polyunfill (element) {
                         if (is_field(element)) {

                           uninstall_property(element, 'checkValidity');
                           uninstall_property(element, 'reportValidity');
                           uninstall_property(element, 'setCustomValidity');
                           uninstall_property(element, 'stepDown');
                           uninstall_property(element, 'stepUp');
                           uninstall_property(element, 'validationMessage');
                           uninstall_property(element, 'validity');
                           uninstall_property(element, 'valueAsDate');
                           uninstall_property(element, 'valueAsNumber');
                           uninstall_property(element, 'willValidate');

                           uninstall_properties(element);
                         } else if (element instanceof window.HTMLFormElement) {
                           uninstall_property(element, 'checkValidity');
                           uninstall_property(element, 'reportValidity');
                         }
                       }

                       var instances = new WeakMap();

                       /**
                        * wrap <form>s, window or document, that get treated with the global
                        * hyperform()
                        */
                       function Wrapper(form, settings) {

                         /* do not allow more than one instance per form. Otherwise we'd end
                          * up with double event handlers, polyfills re-applied, ... */
                         var existing = instances.get(form);
                         if (existing) {
                           existing.settings = settings;
                           return existing;
                         }

                         this.form = form;
                         this.settings = settings;
                         this.revalidator = this.revalidate.bind(this);

                         instances.set(form, this);

                         catch_submit(form, settings.revalidate === 'never');

                         if (form === window || form.nodeType === 9) {
                           /* install on the prototypes, when called for the whole document */
                           this.install([window.HTMLButtonElement.prototype, window.HTMLInputElement.prototype, window.HTMLSelectElement.prototype, window.HTMLTextAreaElement.prototype, window.HTMLFieldSetElement.prototype]);
                           polyfill(window.HTMLFormElement);
                         } else if (form instanceof window.HTMLFormElement || form instanceof window.HTMLFieldSetElement) {
                           this.install(form.elements);
                           if (form instanceof window.HTMLFormElement) {
                             polyfill(form);
                           }
                         }

                         if (settings.revalidate === 'oninput' || settings.revalidate === 'hybrid') {
                           /* in a perfect world we'd just bind to "input", but support here is
                            * abysmal: http://caniuse.com/#feat=input-event */
                           form.addEventListener('keyup', this.revalidator);
                           form.addEventListener('change', this.revalidator);
                         }
                         if (settings.revalidate === 'onblur' || settings.revalidate === 'hybrid') {
                           /* useCapture=true, because `blur` doesn't bubble. See
                            * https://developer.mozilla.org/en-US/docs/Web/Events/blur#Event_delegation
                            * for a discussion */
                           form.addEventListener('blur', this.revalidator, true);
                         }
                       }

                       Wrapper.prototype = {
                         destroy: function destroy() {
                           uncatch_submit(this.form);
                           instances.delete(this.form);
                           this.form.removeEventListener('keyup', this.revalidator);
                           this.form.removeEventListener('change', this.revalidator);
                           this.form.removeEventListener('blur', this.revalidator, true);
                           if (this.form === window || this.form.nodeType === 9) {
                             this.uninstall([window.HTMLButtonElement.prototype, window.HTMLInputElement.prototype, window.HTMLSelectElement.prototype, window.HTMLTextAreaElement.prototype, window.HTMLFieldSetElement.prototype]);
                             polyunfill(window.HTMLFormElement);
                           } else if (this.form instanceof window.HTMLFormElement || this.form instanceof window.HTMLFieldSetElement) {
                             this.uninstall(this.form.elements);
                             if (this.form instanceof window.HTMLFormElement) {
                               polyunfill(this.form);
                             }
                           }
                         },


                         /**
                          * revalidate an input element
                          */
                         revalidate: function revalidate(event) {
                           if (event.target instanceof window.HTMLButtonElement || event.target instanceof window.HTMLTextAreaElement || event.target instanceof window.HTMLSelectElement || event.target instanceof window.HTMLInputElement) {

                             if (this.settings.revalidate === 'hybrid') {
                               /* "hybrid" somewhat simulates what browsers do. See for example
                                * Firefox's :-moz-ui-invalid pseudo-class:
                                * https://developer.mozilla.org/en-US/docs/Web/CSS/:-moz-ui-invalid */
                               if (event.type === 'blur' && event.target.value !== event.target.defaultValue || ValidityState(event.target).valid) {
                                 /* on blur, update the report when the value has changed from the
                                  * default or when the element is valid (possibly removing a still
                                  * standing invalidity report). */
                                 reportValidity(event.target);
                               } else if (event.type === 'keyup' || event.type === 'change') {
                                 if (ValidityState(event.target).valid) {
                                   // report instantly, when an element becomes valid,
                                   // postpone report to blur event, when an element is invalid
                                   reportValidity(event.target);
                                 }
                               }
                             } else {
                               reportValidity(event.target);
                             }
                           }
                         },


                         /**
                          * install the polyfills on each given element
                          *
                          * If you add elements dynamically, you have to call install() on them
                          * yourself:
                          *
                          * js> var form = hyperform(document.forms[0]);
                          * js> document.forms[0].appendChild(input);
                          * js> form.install(input);
                          *
                          * You can skip this, if you called hyperform on window or document.
                          */
                         install: function install(els) {
                           if (els instanceof window.Element) {
                             els = [els];
                           }

                           var els_length = els.length;

                           for (var i = 0; i < els_length; i++) {
                             polyfill(els[i]);
                           }
                         },
                         uninstall: function uninstall(els) {
                           if (els instanceof window.Element) {
                             els = [els];
                           }

                           var els_length = els.length;

                           for (var i = 0; i < els_length; i++) {
                             polyunfill(els[i]);
                           }
                         }
                       };

                       /**
                        * try to get the appropriate wrapper for a specific element by looking up
                        * its parent chain
                        *
                        * @return Wrapper | undefined
                        */
                       function get_wrapper(element) {
                         var wrapped;

                         if (element.form) {
                           /* try a shortcut with the element's <form> */
                           wrapped = instances.get(element.form);
                         }

                         /* walk up the parent nodes until document (including) */
                         while (!wrapped && element) {
                           wrapped = instances.get(element);
                           element = element.parentNode;
                         }

                         if (!wrapped) {
                           /* try the global instance, if exists. This may also be undefined. */
                           wrapped = instances.get(window);
                         }

                         return wrapped;
                       }

                       /**
                        * check if an element is a candidate for constraint validation
                        *
                        * @see https://html.spec.whatwg.org/multipage/forms.html#barred-from-constraint-validation
                        */
                       function is_validation_candidate (element) {

                         /* allow a shortcut via filters, e.g. to validate type=hidden fields */
                         var filtered = do_filter('is_validation_candidate', null, element);
                         if (filtered !== null) {
                           return !!filtered;
                         }

                         /* it must be any of those elements */
                         if (element instanceof window.HTMLSelectElement || element instanceof window.HTMLTextAreaElement || element instanceof window.HTMLButtonElement || element instanceof window.HTMLInputElement) {

                           var type = get_type(element);
                           /* its type must be in the whitelist */
                           if (non_inputs.indexOf(type) > -1 || validation_candidates.indexOf(type) > -1) {

                             /* it mustn't be disabled or readonly */
                             if (!element.hasAttribute('disabled') && !element.hasAttribute('readonly')) {

                               var wrapped_form = get_wrapper(element);

                               /* it must have a name (or validating nameless inputs is allowed) */
                               if (element.getAttribute('name') || wrapped_form && wrapped_form.settings.validateNameless) {

                                 if (
                                 /* the parent form doesn't allow non-standard "novalidate" attributes... */
                                 wrapped_form && !wrapped_form.settings.novalidateOnElements ||
                                 /* ...or it doesn't have such an attribute/property */
                                 !element.hasAttribute('novalidate') && !element.noValidate) {

                                   /* it isn't part of a <fieldset disabled> */
                                   var p = element.parentNode;
                                   while (p && p.nodeType === 1) {
                                     if (p instanceof window.HTMLFieldSetElement && p.hasAttribute('disabled')) {
                                       /* quick return, if it's a child of a disabled fieldset */
                                       return false;
                                     } else if (p.nodeName.toUpperCase() === 'DATALIST') {
                                       /* quick return, if it's a child of a datalist
                                        * Do not use HTMLDataListElement to support older browsers,
                                        * too.
                                        * @see https://html.spec.whatwg.org/multipage/forms.html#the-datalist-element:barred-from-constraint-validation
                                        */
                                       return false;
                                     } else if (p === element.form) {
                                       /* the outer boundary. We can stop looking for relevant
                                        * fieldsets. */
                                       break;
                                     }
                                     p = p.parentNode;
                                   }

                                   /* then it's a candidate */
                                   return true;
                                 }
                               }
                             }
                           }
                         }

                         /* this is no HTML5 validation candidate... */
                         return false;
                       }

                       function format_date (date) {
                         var part = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

                         switch (part) {
                           case 'date':
                             return (date.toLocaleDateString || date.toDateString).call(date);
                           case 'time':
                             return (date.toLocaleTimeString || date.toTimeString).call(date);
                           case 'month':
                             return 'toLocaleDateString' in date ? date.toLocaleDateString(undefined, {
                               year: 'numeric',
                               month: '2-digit'
                             }) : date.toDateString();
                           // case 'week':
                           // TODO
                           default:
                             return (date.toLocaleString || date.toString).call(date);
                         }
                       }

                       /**
                        * patch String.length to account for non-BMP characters
                        *
                        * @see https://mathiasbynens.be/notes/javascript-unicode
                        * We do not use the simple [...str].length, because it needs a ton of
                        * polyfills in older browsers.
                        */

                       function unicode_string_length (str) {
                         return str.match(/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g).length;
                       }

                       /**
                        * internal storage for custom error messages
                        */

                       var store$1 = new WeakMap();

                       /**
                        * register custom error messages per element
                        */
                       var custom_messages = {
                         set: function set(element, validator, message) {
                           var messages = store$1.get(element) || {};
                           messages[validator] = message;
                           store$1.set(element, messages);
                           return custom_messages;
                         },
                         get: function get(element, validator) {
                           var _default = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

                           var messages = store$1.get(element);
                           if (messages === undefined || !(validator in messages)) {
                             var data_id = 'data-' + validator.replace(/[A-Z]/g, '-$&').toLowerCase();
                             if (element.hasAttribute(data_id)) {
                               /* if the element has a data-validator attribute, use this as fallback.
                                * E.g., if validator == 'valueMissing', the element can specify a
                                * custom validation message like this:
                                *     <input data-value-missing="Oh noes!">
                                */
                               return element.getAttribute(data_id);
                             }
                             return _default;
                           }
                           return messages[validator];
                         },
                         delete: function _delete(element) {
                           var validator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                           if (!validator) {
                             return store$1.delete(element);
                           }
                           var messages = store$1.get(element) || {};
                           if (validator in messages) {
                             delete messages[validator];
                             store$1.set(element, messages);
                             return true;
                           }
                           return false;
                         }
                       };

                       var internal_registry = new WeakMap();

                       /**
                        * A registry for custom validators
                        *
                        * slim wrapper around a WeakMap to ensure the values are arrays
                        * (hence allowing > 1 validators per element)
                        */
                       var custom_validator_registry = {
                         set: function set(element, validator) {
                           var current = internal_registry.get(element) || [];
                           current.push(validator);
                           internal_registry.set(element, current);
                           return custom_validator_registry;
                         },
                         get: function get(element) {
                           return internal_registry.get(element) || [];
                         },
                         delete: function _delete(element) {
                           return internal_registry.delete(element);
                         }
                       };

                       /**
                        * test whether the element suffers from bad input
                        */
                       function test_bad_input (element) {
                         var type = get_type(element);

                         if (!is_validation_candidate(element) || input_checked.indexOf(type) === -1) {
                           /* we're not interested, thanks! */
                           return true;
                         }

                         /* the browser hides some bad input from the DOM, e.g. malformed numbers,
                          * email addresses with invalid punycode representation, ... We try to resort
                          * to the original method here. The assumption is, that a browser hiding
                          * bad input will hopefully also always support a proper
                          * ValidityState.badInput */
                         if (!element.value) {
                           if ('_original_validity' in element && !element._original_validity.__hyperform) {
                             return !element._original_validity.badInput;
                           }
                           /* no value and no original badInput: Assume all's right. */
                           return true;
                         }

                         var result = true;
                         switch (type) {
                           case 'color':
                             result = /^#[a-f0-9]{6}$/.test(element.value);
                             break;
                           case 'number':
                           case 'range':
                             result = !isNaN(Number(element.value));
                             break;
                           case 'datetime':
                           case 'date':
                           case 'month':
                           case 'week':
                           case 'time':
                             result = string_to_date(element.value, type) !== null;
                             break;
                           case 'datetime-local':
                             result = /^([0-9]{4,})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])T([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\.([0-9]{1,3}))?)?$/.test(element.value);
                             break;
                           case 'tel':
                             /* spec says No! Phone numbers can have all kinds of formats, so this
                              * is expected to be a free-text field. */
                             // TODO we could allow a setting 'phone_regex' to be evaluated here.
                             break;
                           case 'email':
                             break;
                         }

                         return result;
                       }

                       /**
                        * test the max attribute
                        *
                        * we use Number() instead of parseFloat(), because an invalid attribute
                        * value like "123abc" should result in an error.
                        */
                       function test_max (element) {
                         var type = get_type(element);

                         if (!is_validation_candidate(element) || !element.value || !element.hasAttribute('max')) {
                           /* we're not responsible here */
                           return true;
                         }

                         var value = void 0,
                             max = void 0;
                         if (dates.indexOf(type) > -1) {
                           value = 1 * string_to_date(element.value, type);
                           max = 1 * (string_to_date(element.getAttribute('max'), type) || NaN);
                         } else {
                           value = Number(element.value);
                           max = Number(element.getAttribute('max'));
                         }

                         return isNaN(max) || value <= max;
                       }

                       /**
                        * test the maxlength attribute
                        */
                       function test_maxlength (element) {
                         if (!is_validation_candidate(element) || !element.value || text_types.indexOf(get_type(element)) === -1 || !element.hasAttribute('maxlength') || !element.getAttribute('maxlength') // catch maxlength=""
                         ) {
                             return true;
                           }

                         var maxlength = parseInt(element.getAttribute('maxlength'), 10);

                         /* check, if the maxlength value is usable at all.
                          * We allow maxlength === 0 to basically disable input (Firefox does, too).
                          */
                         if (isNaN(maxlength) || maxlength < 0) {
                           return true;
                         }

                         return unicode_string_length(element.value) <= maxlength;
                       }

                       /**
                        * test the min attribute
                        *
                        * we use Number() instead of parseFloat(), because an invalid attribute
                        * value like "123abc" should result in an error.
                        */
                       function test_min (element) {
                         var type = get_type(element);

                         if (!is_validation_candidate(element) || !element.value || !element.hasAttribute('min')) {
                           /* we're not responsible here */
                           return true;
                         }

                         var value = void 0,
                             min = void 0;
                         if (dates.indexOf(type) > -1) {
                           value = 1 * string_to_date(element.value, type);
                           min = 1 * (string_to_date(element.getAttribute('min'), type) || NaN);
                         } else {
                           value = Number(element.value);
                           min = Number(element.getAttribute('min'));
                         }

                         return isNaN(min) || value >= min;
                       }

                       /**
                        * test the minlength attribute
                        */
                       function test_minlength (element) {
                         if (!is_validation_candidate(element) || !element.value || text_types.indexOf(get_type(element)) === -1 || !element.hasAttribute('minlength') || !element.getAttribute('minlength') // catch minlength=""
                         ) {
                             return true;
                           }

                         var minlength = parseInt(element.getAttribute('minlength'), 10);

                         /* check, if the minlength value is usable at all. */
                         if (isNaN(minlength) || minlength < 0) {
                           return true;
                         }

                         return unicode_string_length(element.value) >= minlength;
                       }

                       /**
                        * test the pattern attribute
                        */
                       function test_pattern (element) {
                           return !is_validation_candidate(element) || !element.value || !element.hasAttribute('pattern') || new RegExp('^(?:' + element.getAttribute('pattern') + ')$').test(element.value);
                       }

                       /**
                        * test the required attribute
                        */
                       function test_required (element) {
                         if (!is_validation_candidate(element) || !element.hasAttribute('required')) {
                           /* nothing to do */
                           return true;
                         }

                         /* we don't need get_type() for element.type, because "checkbox" and "radio"
                          * are well supported. */
                         switch (element.type) {
                           case 'checkbox':
                             return element.checked;
                           //break;
                           case 'radio':
                             /* radio inputs have "required" fulfilled, if _any_ other radio
                              * with the same name in this form is checked. */
                             return !!(element.checked || element.form && Array.prototype.filter.call(document.getElementsByName(element.name), function (radio) {
                               return radio.name === element.name && radio.form === element.form && radio.checked;
                             }).length > 0);
                           //break;
                           default:
                             return !!element.value;
                         }
                       }

                       /**
                        * test the step attribute
                        */
                       function test_step (element) {
                         var type = get_type(element);

                         if (!is_validation_candidate(element) || !element.value || numbers.indexOf(type) === -1 || (element.getAttribute('step') || '').toLowerCase() === 'any') {
                           /* we're not responsible here. Note: If no step attribute is given, we
                            * need to validate against the default step as per spec. */
                           return true;
                         }

                         var step = element.getAttribute('step');
                         if (step) {
                           step = string_to_number(step, type);
                         } else {
                           step = default_step[type] || 1;
                         }

                         if (step <= 0 || isNaN(step)) {
                           /* error in specified "step". We cannot validate against it, so the value
                            * is true. */
                           return true;
                         }

                         var scale = step_scale_factor[type] || 1;

                         var value = string_to_number(element.value, type);
                         var min = string_to_number(element.getAttribute('min') || element.getAttribute('value') || '', type);

                         if (isNaN(min)) {
                           min = default_step_base[type] || 0;
                         }

                         if (type === 'month') {
                           /* type=month has month-wide steps. See
                            * https://html.spec.whatwg.org/multipage/forms.html#month-state-%28type=month%29
                            */
                           min = new Date(min).getUTCFullYear() * 12 + new Date(min).getUTCMonth();
                           value = new Date(value).getUTCFullYear() * 12 + new Date(value).getUTCMonth();
                         }

                         var result = Math.abs(min - value) % (step * scale);

                         return result < 0.00000001 ||
                         /* crappy floating-point arithmetics! */
                         result > step * scale - 0.00000001;
                       }

                       var ws_on_start_or_end = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

                       /**
                        * trim a string of whitespace
                        *
                        * We don't use String.trim() to remove the need to polyfill it.
                        */
                       function trim (str) {
                         return str.replace(ws_on_start_or_end, '');
                       }

                       /**
                        * split a string on comma and trim the components
                        *
                        * As specified at
                        * https://html.spec.whatwg.org/multipage/infrastructure.html#split-a-string-on-commas
                        * plus removing empty entries.
                        */
                       function comma_split (str) {
                         return str.split(',').map(function (item) {
                           return trim(item);
                         }).filter(function (b) {
                           return b;
                         });
                       }

                       /* we use a dummy <a> where we set the href to test URL validity
                        * The definition is out of the "global" scope so that JSDOM can be instantiated
                        * after loading Hyperform for tests.
                        */
                       var url_canary;

                       /* see https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address */
                       var email_pattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

                       /**
                        * test the type-inherent syntax
                        */
                       function test_type (element) {
                         var type = get_type(element);

                         if (!is_validation_candidate(element) || type !== 'file' && !element.value || type !== 'file' && type_checked.indexOf(type) === -1) {
                           /* we're not responsible for this element */
                           return true;
                         }

                         var is_valid = true;

                         switch (type) {
                           case 'url':
                             if (!url_canary) {
                               url_canary = document.createElement('a');
                             }
                             var value = trim(element.value);
                             url_canary.href = value;
                             is_valid = url_canary.href === value || url_canary.href === value + '/';
                             break;
                           case 'email':
                             if (element.hasAttribute('multiple')) {
                               is_valid = comma_split(element.value).every(function (value) {
                                 return email_pattern.test(value);
                               });
                             } else {
                               is_valid = email_pattern.test(trim(element.value));
                             }
                             break;
                           case 'file':
                             if ('files' in element && element.files.length && element.hasAttribute('accept')) {
                               var patterns = comma_split(element.getAttribute('accept')).map(function (pattern) {
                                 if (/^(audio|video|image)\/\*$/.test(pattern)) {
                                   pattern = new RegExp('^' + RegExp.$1 + '/.+$');
                                 }
                                 return pattern;
                               });

                               if (!patterns.length) {
                                 break;
                               }

                               fileloop: for (var i = 0; i < element.files.length; i++) {
                                 /* we need to match a whitelist, so pre-set with false */
                                 var file_valid = false;

                                 patternloop: for (var j = 0; j < patterns.length; j++) {
                                   var file = element.files[i];
                                   var pattern = patterns[j];

                                   var fileprop = file.type;

                                   if (typeof pattern === 'string' && pattern.substr(0, 1) === '.') {
                                     if (file.name.search('.') === -1) {
                                       /* no match with any file ending */
                                       continue patternloop;
                                     }

                                     fileprop = file.name.substr(file.name.lastIndexOf('.'));
                                   }

                                   if (fileprop.search(pattern) === 0) {
                                     /* we found one match and can quit looking */
                                     file_valid = true;
                                     break patternloop;
                                   }
                                 }

                                 if (!file_valid) {
                                   is_valid = false;
                                   break fileloop;
                                 }
                               }
                             }
                         }

                         return is_valid;
                       }

                       /**
                        * boilerplate function for all tests but customError
                        */
                       function check$1(test, react) {
                         return function (element) {
                           var invalid = !test(element);
                           if (invalid) {
                             react(element);
                           }
                           return invalid;
                         };
                       }

                       /**
                        * create a common function to set error messages
                        */
                       function set_msg(element, msgtype, _default) {
                         message_store.set(element, custom_messages.get(element, msgtype, _default));
                       }

                       var badInput = check$1(test_bad_input, function (element) {
                         return set_msg(element, 'badInput', _('Please match the requested type.'));
                       });

                       function customError(element) {
                         /* check, if there are custom validators in the registry, and call
                          * them. */
                         var custom_validators = custom_validator_registry.get(element);
                         var cvl = custom_validators.length;
                         var valid = true;

                         if (cvl) {
                           for (var i = 0; i < cvl; i++) {
                             var result = custom_validators[i](element);
                             if (result !== undefined && !result) {
                               valid = false;
                               /* break on first invalid response */
                               break;
                             }
                           }
                         }

                         /* check, if there are other validity messages already */
                         if (valid) {
                           var msg = message_store.get(element);
                           valid = !(msg.toString() && 'is_custom' in msg);
                         }

                         return !valid;
                       }

                       var patternMismatch = check$1(test_pattern, function (element) {
                         set_msg(element, 'patternMismatch', element.title ? sprintf(_('PatternMismatchWithTitle'), element.title) : _('PatternMismatch'));
                       });

                       /**
                        * TODO: when rangeOverflow and rangeUnderflow are both called directly and
                        * successful, the inRange and outOfRange classes won't get removed, unless
                        * element.validityState.valid is queried, too.
                        */
                       var rangeOverflow = check$1(test_max, function (element) {
                         var type = get_type(element);
                         var wrapper = get_wrapper(element);
                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';
                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';

                         var msg = void 0;

                         switch (type) {
                           case 'date':
                           case 'datetime':
                           case 'datetime-local':
                             msg = sprintf(_('DateRangeOverflow'), format_date(string_to_date(element.getAttribute('max'), type), type));
                             break;
                           case 'time':
                             msg = sprintf(_('TimeRangeOverflow'), format_date(string_to_date(element.getAttribute('max'), type), type));
                             break;
                           // case 'number':
                           default:
                             msg = sprintf(_('NumberRangeOverflow'), string_to_number(element.getAttribute('max'), type));
                             break;
                         }

                         set_msg(element, 'rangeOverflow', msg);
                         element.classList.add(outOfRangeClass);
                         element.classList.remove(inRangeClass);
                       });

                       var rangeUnderflow = check$1(test_min, function (element) {
                         var type = get_type(element);
                         var wrapper = get_wrapper(element);
                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';
                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';

                         var msg = void 0;

                         switch (type) {
                           case 'date':
                           case 'datetime':
                           case 'datetime-local':
                             msg = sprintf(_('DateRangeUnderflow'), format_date(string_to_date(element.getAttribute('min'), type), type));
                             break;
                           case 'time':
                             msg = sprintf(_('TimeRangeUnderflow'), format_date(string_to_date(element.getAttribute('min'), type), type));
                             break;
                           // case 'number':
                           default:
                             msg = sprintf(_('NumberRangeUnderflow'), string_to_number(element.getAttribute('min'), type));
                             break;
                         }

                         set_msg(element, 'rangeUnderflow', msg);
                         element.classList.add(outOfRangeClass);
                         element.classList.remove(inRangeClass);
                       });

                       var stepMismatch = check$1(test_step, function (element) {
                         var list = get_next_valid(element);
                         var min = list[0];
                         var max = list[1];
                         var sole = false;
                         var msg = void 0;

                         if (min === null) {
                           sole = max;
                         } else if (max === null) {
                           sole = min;
                         }

                         if (sole !== false) {
                           msg = sprintf(_('StepMismatchOneValue'), sole);
                         } else {
                           msg = sprintf(_('StepMismatch'), min, max);
                         }
                         set_msg(element, 'stepMismatch', msg);
                       });

                       var tooLong = check$1(test_maxlength, function (element) {
                         set_msg(element, 'tooLong', sprintf(_('TextTooLong'), element.getAttribute('maxlength'), unicode_string_length(element.value)));
                       });

                       var tooShort = check$1(test_minlength, function (element) {
                         set_msg(element, 'tooShort', sprintf(_('Please lengthen this text to %l characters or more (you are currently using %l characters).'), element.getAttribute('minlength'), unicode_string_length(element.value)));
                       });

                       var typeMismatch = check$1(test_type, function (element) {
                         var msg = _('Please use the appropriate format.');
                         var type = get_type(element);

                         if (type === 'email') {
                           if (element.hasAttribute('multiple')) {
                             msg = _('Please enter a comma separated list of email addresses.');
                           } else {
                             msg = _('InvalidEmail');
                           }
                         } else if (type === 'url') {
                           msg = _('InvalidURL');
                         } else if (type === 'file') {
                           msg = _('Please select a file of the correct type.');
                         }

                         set_msg(element, 'typeMismatch', msg);
                       });

                       var valueMissing = check$1(test_required, function (element) {
                         var msg = _('ValueMissing');
                         var type = get_type(element);

                         if (type === 'checkbox') {
                           msg = _('CheckboxMissing');
                         } else if (type === 'radio') {
                           msg = _('RadioMissing');
                         } else if (type === 'file') {
                           if (element.hasAttribute('multiple')) {
                             msg = _('Please select one or more files.');
                           } else {
                             msg = _('FileMissing');
                           }
                         } else if (element instanceof window.HTMLSelectElement) {
                           msg = _('SelectMissing');
                         }

                         set_msg(element, 'valueMissing', msg);
                       });

                       var validity_state_checkers = {
                         badInput: badInput,
                         customError: customError,
                         patternMismatch: patternMismatch,
                         rangeOverflow: rangeOverflow,
                         rangeUnderflow: rangeUnderflow,
                         stepMismatch: stepMismatch,
                         tooLong: tooLong,
                         tooShort: tooShort,
                         typeMismatch: typeMismatch,
                         valueMissing: valueMissing
                       };

                       /**
                        * the validity state constructor
                        */
                       var ValidityState = function ValidityState(element) {
                         if (!(element instanceof window.HTMLElement)) {
                           throw new Error('cannot create a ValidityState for a non-element');
                         }

                         var cached = ValidityState.cache.get(element);
                         if (cached) {
                           return cached;
                         }

                         if (!(this instanceof ValidityState)) {
                           /* working around a forgotten `new` */
                           return new ValidityState(element);
                         }

                         this.element = element;
                         ValidityState.cache.set(element, this);
                       };

                       /**
                        * the prototype for new validityState instances
                        */
                       var ValidityStatePrototype = {};
                       ValidityState.prototype = ValidityStatePrototype;

                       ValidityState.cache = new WeakMap();

                       /**
                        * copy functionality from the validity checkers to the ValidityState
                        * prototype
                        */
                       for (var prop in validity_state_checkers) {
                         Object.defineProperty(ValidityStatePrototype, prop, {
                           configurable: true,
                           enumerable: true,
                           get: function (func) {
                             return function () {
                               return func(this.element);
                             };
                           }(validity_state_checkers[prop]),
                           set: undefined
                         });
                       }

                       /**
                        * the "valid" property calls all other validity checkers and returns true,
                        * if all those return false.
                        *
                        * This is the major access point for _all_ other API methods, namely
                        * (check|report)Validity().
                        */
                       Object.defineProperty(ValidityStatePrototype, 'valid', {
                         configurable: true,
                         enumerable: true,
                         get: function get() {
                           var wrapper = get_wrapper(this.element);
                           var validClass = wrapper && wrapper.settings.classes.valid || 'hf-valid';
                           var invalidClass = wrapper && wrapper.settings.classes.invalid || 'hf-invalid';
                           var userInvalidClass = wrapper && wrapper.settings.classes.userInvalid || 'hf-user-invalid';
                           var userValidClass = wrapper && wrapper.settings.classes.userValid || 'hf-user-valid';
                           var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';
                           var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';
                           var validatedClass = wrapper && wrapper.settings.classes.validated || 'hf-validated';

                           this.element.classList.add(validatedClass);

                           if (is_validation_candidate(this.element)) {
                             for (var _prop in validity_state_checkers) {
                               if (validity_state_checkers[_prop](this.element)) {
                                 this.element.classList.add(invalidClass);
                                 this.element.classList.remove(validClass);
                                 this.element.classList.remove(userValidClass);
                                 if (this.element.value !== this.element.defaultValue) {
                                   this.element.classList.add(userInvalidClass);
                                 } else {
                                   this.element.classList.remove(userInvalidClass);
                                 }
                                 this.element.setAttribute('aria-invalid', 'true');
                                 return false;
                               }
                             }
                           }

                           message_store.delete(this.element);
                           this.element.classList.remove(invalidClass);
                           this.element.classList.remove(userInvalidClass);
                           this.element.classList.remove(outOfRangeClass);
                           this.element.classList.add(validClass);
                           this.element.classList.add(inRangeClass);
                           if (this.element.value !== this.element.defaultValue) {
                             this.element.classList.add(userValidClass);
                           } else {
                             this.element.classList.remove(userValidClass);
                           }
                           this.element.setAttribute('aria-invalid', 'false');
                           return true;
                         },
                         set: undefined
                       });

                       /**
                        * mark the validity prototype, because that is what the client-facing
                        * code deals with mostly, not the property descriptor thing */
                       mark(ValidityStatePrototype);

                       /**
                        * check an element's validity with respect to it's form
                        */
                       var checkValidity = return_hook_or('checkValidity', function (element) {
                         /* if this is a <form>, check validity of all child inputs */
                         if (element instanceof window.HTMLFormElement) {
                           return Array.prototype.map.call(element.elements, checkValidity).every(function (b) {
                             return b;
                           });
                         }

                         /* default is true, also for elements that are no validation candidates */
                         var valid = ValidityState(element).valid;
                         if (valid) {
                           var wrapped_form = get_wrapper(element);
                           if (wrapped_form && wrapped_form.settings.validEvent) {
                             trigger_event(element, 'valid');
                           }
                         } else {
                           trigger_event(element, 'invalid', { cancelable: true });
                         }

                         return valid;
                       });

                       var version = '0.9.12';

                       /* deprecate the old snake_case names
                        * TODO: delme before next non-patch release
                        */
                       function w(name) {
                         var deprecated_message = 'Please use camelCase method names! The name "%s" is deprecated and will be removed in the next non-patch release.';
                         /* global console */
                         console.log(sprintf(deprecated_message, name));
                       }

                       /**
                        * public hyperform interface:
                        */
                       function hyperform(form) {
                         var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                         var classes = _ref.classes;
                         var _ref$debug = _ref.debug;
                         var debug = _ref$debug === undefined ? false : _ref$debug;
                         var extend_fieldset = _ref.extend_fieldset;
                         var extendFieldset = _ref.extendFieldset;
                         var novalidate_on_elements = _ref.novalidate_on_elements;
                         var novalidateOnElements = _ref.novalidateOnElements;
                         var prevent_implicit_submit = _ref.prevent_implicit_submit;
                         var preventImplicitSubmit = _ref.preventImplicitSubmit;
                         var revalidate = _ref.revalidate;
                         var _ref$strict = _ref.strict;
                         var strict = _ref$strict === undefined ? false : _ref$strict;
                         var valid_event = _ref.valid_event;
                         var validEvent = _ref.validEvent;
                         var _ref$validateNameless = _ref.validateNameless;
                         var validateNameless = _ref$validateNameless === undefined ? false : _ref$validateNameless;


                         if (!classes) {
                           classes = {};
                         }
                         // TODO: clean up before next non-patch release
                         if (extendFieldset === undefined) {
                           if (extend_fieldset === undefined) {
                             extendFieldset = !strict;
                           } else {
                             w('extend_fieldset');
                             extendFieldset = extend_fieldset;
                           }
                         }
                         if (novalidateOnElements === undefined) {
                           if (novalidate_on_elements === undefined) {
                             novalidateOnElements = !strict;
                           } else {
                             w('novalidate_on_elements');
                             novalidateOnElements = novalidate_on_elements;
                           }
                         }
                         if (preventImplicitSubmit === undefined) {
                           if (prevent_implicit_submit === undefined) {
                             preventImplicitSubmit = false;
                           } else {
                             w('prevent_implicit_submit');
                             preventImplicitSubmit = prevent_implicit_submit;
                           }
                         }
                         if (revalidate === undefined) {
                           /* other recognized values: 'oninput', 'onblur', 'onsubmit' and 'never' */
                           revalidate = strict ? 'onsubmit' : 'hybrid';
                         }
                         if (validEvent === undefined) {
                           if (valid_event === undefined) {
                             validEvent = !strict;
                           } else {
                             w('valid_event');
                             validEvent = valid_event;
                           }
                         }

                         var settings = { debug: debug, strict: strict, preventImplicitSubmit: preventImplicitSubmit, revalidate: revalidate,
                           validEvent: validEvent, extendFieldset: extendFieldset, classes: classes, novalidateOnElements: novalidateOnElements,
                           validateNameless: validateNameless
                         };

                         if (form instanceof window.NodeList || form instanceof window.HTMLCollection || form instanceof Array) {
                           return Array.prototype.map.call(form, function (element) {
                             return hyperform(element, settings);
                           });
                         }

                         return new Wrapper(form, settings);
                       }

                       hyperform.version = version;

                       hyperform.checkValidity = checkValidity;
                       hyperform.reportValidity = reportValidity;
                       hyperform.setCustomValidity = setCustomValidity;
                       hyperform.stepDown = stepDown;
                       hyperform.stepUp = stepUp;
                       hyperform.validationMessage = validationMessage;
                       hyperform.ValidityState = ValidityState;
                       hyperform.valueAsDate = valueAsDate;
                       hyperform.valueAsNumber = valueAsNumber;
                       hyperform.willValidate = willValidate;

                       hyperform.setLanguage = function (lang) {
                         set_language(lang);return hyperform;
                       };
                       hyperform.addTranslation = function (lang, catalog) {
                         add_translation(lang, catalog);return hyperform;
                       };
                       hyperform.setRenderer = function (renderer, action) {
                         Renderer.set(renderer, action);return hyperform;
                       };
                       hyperform.addValidator = function (element, validator) {
                         custom_validator_registry.set(element, validator);return hyperform;
                       };
                       hyperform.setMessage = function (element, validator, message) {
                         custom_messages.set(element, validator, message);return hyperform;
                       };
                       hyperform.addHook = function (hook, action, position) {
                         add_hook(hook, action, position);return hyperform;
                       };
                       hyperform.removeHook = function (hook, action) {
                         remove_hook(hook, action);return hyperform;
                       };

                       // TODO: Remove in next non-patch version
                       hyperform.set_language = function (lang) {
                         w('set_language');set_language(lang);return hyperform;
                       };
                       hyperform.add_translation = function (lang, catalog) {
                         w('add_translation');add_translation(lang, catalog);return hyperform;
                       };
                       hyperform.set_renderer = function (renderer, action) {
                         w('set_renderer');Renderer.set(renderer, action);return hyperform;
                       };
                       hyperform.add_validator = function (element, validator) {
                         w('add_validator');custom_validator_registry.set(element, validator);return hyperform;
                       };
                       hyperform.set_message = function (element, validator, message) {
                         w('set_message');custom_messages.set(element, validator, message);return hyperform;
                       };
                       hyperform.add_hook = function (hook, action, position) {
                         w('add_hook');add_hook(hook, action, position);return hyperform;
                       };
                       hyperform.remove_hook = function (hook, action) {
                         w('remove_hook');remove_hook(hook, action);return hyperform;
                       };

                       if (document.currentScript && document.currentScript.hasAttribute('data-hf-autoload')) {
                         hyperform(window);
                       }

                       return hyperform;

}());

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "		id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.id : depth0), depth0))
    + "\"\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    return "		id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? depths[1].id : depths[1]), depth0))
    + "\"\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "		name=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "\"\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? depths[1].name : depths[1]),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.program(10, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    return "		name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? depths[1].name : depths[1]), depth0))
    + "\"\n";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? depths[2].name : depths[2]),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.program(11, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.id : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n	";
},"12":function(container,depth0,helpers,partials,data) {
    var helper;

  return "			name=\""
    + container.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? depths[1].id : depths[1]),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.program(17, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data,blockParams,depths) {
    return "			name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? depths[1].id : depths[1]), depth0))
    + "\"\n";
},"17":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? depths[2].id : depths[2]),{"name":"if","hash":{},"fn":container.program(18, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"18":function(container,depth0,helpers,partials,data,blockParams,depths) {
    return "			name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? depths[1].id : depths[1]), depth0))
    + "\"\n		";
},"20":function(container,depth0,helpers,partials,data) {
    return " "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.classes : depth0), depth0));
},"22":function(container,depth0,helpers,partials,data) {
    return "		required\n";
},"24":function(container,depth0,helpers,partials,data) {
    return "		maxlength=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.maxlength : depth0), depth0))
    + "\"\n";
},"26":function(container,depth0,helpers,partials,data) {
    return "		minlength=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.minlength : depth0), depth0))
    + "\"\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "		type=\"text\"\n"
    + ((stack1 = container.invokePartial(partials["form-validation"],"url",{"name":"form-validation","data":data,"indent":"\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"30":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.type : depth0),"",{"name":"ifCond","hash":{},"fn":container.program(31, data, 0),"inverse":container.program(33, data, 0),"data":data})) != null ? stack1 : "");
},"31":function(container,depth0,helpers,partials,data) {
    return "		type=\"text\" \n";
},"33":function(container,depth0,helpers,partials,data) {
    return "		type=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.type : depth0), depth0))
    + "\"\n	";
},"35":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["form-validation"],(depth0 != null ? depth0.validate : depth0),{"name":"form-validation","data":data,"indent":"\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"37":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["form-validation"],(depth0 != null ? depth0.type : depth0),{"name":"form-validation","data":data,"indent":"\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression;

  return "<input\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.id : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.name : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(7, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "	\n	class=\"form-input"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.classes : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\"\n	\n	placeholder=\""
    + alias3(alias2((depth0 != null ? depth0.placeholder : depth0), depth0))
    + "\"\n	\n	value=\""
    + alias3(alias2((depth0 != null ? depth0.value : depth0), depth0))
    + "\"\n	\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.required : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.maxlength : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.minlength : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(alias1,(depth0 != null ? depth0.type : depth0),"url",{"name":"ifCond","hash":{},"fn":container.program(28, data, 0, blockParams, depths),"inverse":container.program(30, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n	\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.validate : depth0),{"name":"if","hash":{},"fn":container.program(35, data, 0, blockParams, depths),"inverse":container.program(37, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n/>";
},"usePartial":true,"useData":true,"useDepths":true});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$\"\"\n\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"letters",{"name":"ifCond","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[àÀáÁâÂãÃäÄèÈéÉêÊëËìÌíÍĩĨïÏòÒóÓõÕôÔóÓöÖùÙúÚũŨûÛüÜçÇñÑa-zA-Z\\s]+\"\n\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"letters-strict",{"name":"ifCond","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[àÀáÁâÂãÃäÄèÈéÉêÊëËìÌíÍĩĨïÏòÒóÓõÕôÔóÓöÖùÙúÚũŨûÛüÜçÇñÑa-zA-Z]+\"\n\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"letters-loose",{"name":"ifCond","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[àÀáÁâÂãÃäÄèÈéÉêÊëËìÌíÍĩĨïÏòÒóÓõÕôÔóÓöÖùÙúÚũŨûÛüÜçÇñÑa-zA-Z\\s',.\\-]+\"\n\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"number",{"name":"ifCond","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[0-9]+\" onkeydown=\"javascript:window.onlyNumbers(event)\" onkeyup=\"javascript:window.checkNumbers(this)\" \n\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"url",{"name":"ifCond","hash":{},"fn":container.program(16, data, 0),"inverse":container.program(18, data, 0),"data":data})) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"^(?:https?://|s?ftps?://)?(?!www | www\\.)([a-zA-Z0-9]([a-zA-ZäöüÄÖÜ0-9\\-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$\"\n\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"tel",{"name":"ifCond","hash":{},"fn":container.program(19, data, 0),"inverse":container.program(21, data, 0),"data":data})) != null ? stack1 : "");
},"19":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"^[0-9-+s()]*$\"\n\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"title",{"name":"ifCond","hash":{},"fn":container.program(22, data, 0),"inverse":container.program(24, data, 0),"data":data})) != null ? stack1 : "");
},"22":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[àÀáÁâÂãÃäÄèÈéÉêÊëËìÌíÍĩĨïÏòÒóÓõÕôÔóÓöÖùÙúÚũŨûÛüÜçÇñÑa-zA-Z\\-.\\s]+\"\n\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"alphanumeric",{"name":"ifCond","hash":{},"fn":container.program(25, data, 0),"inverse":container.program(27, data, 0),"data":data})) != null ? stack1 : "");
},"25":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[a-zA-Z0-9\\s]+\"\n\n";
},"27":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"alphanumeric-strict",{"name":"ifCond","hash":{},"fn":container.program(28, data, 0),"inverse":container.program(30, data, 0),"data":data})) != null ? stack1 : "");
},"28":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[a-zA-Z0-9]+\"\n\n";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"alphanumeric-loose",{"name":"ifCond","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"31":function(container,depth0,helpers,partials,data) {
    return "data-validate=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"\npattern=\"[àÀáÁâÂãÃäÄèÈéÉêÊëËìÌíÍĩĨïÏòÒóÓõÕôÔóÓöÖùÙúÚũŨûÛüÜçÇñÑa-zA-Z0-9'.\\-\\s]+\"\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.ifCond || (depth0 && depth0.ifCond) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"email",{"name":"ifCond","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " enctype=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0["0"] : depth0)) != null ? stack1.enctype : stack1), depth0))
    + "\"";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<!-- display inline-block space fix\n				\n		--><div class=\"form-item "
    + container.escapeExpression(((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper)))
    + "\">\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.title : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.label : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.input : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.group : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.textarea : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.button : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n		</div><!-- display inline-block space fix\n				\n		-->"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0["space-after"] : depth0),{"name":"if","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<!-- display inline-block space fix\n				\n		-->"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hr : depth0),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<!-- display inline-block space fix\n				\n	-->";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "				<h3 class=\"form-section-title\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h3>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return "				<label class=\"form-label\" for=\""
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.input : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">"
    + alias1(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data}) : helper)))
    + "</label>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "				<div class=\"form-input-wrapper\">\n"
    + ((stack1 = container.invokePartial(partials["form-input"],(depth0 != null ? depth0.input : depth0),{"name":"form-input","data":data,"indent":"\t\t\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "				</div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "				"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.group : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<!-- display inline-block space fix\n				--><div class=\"form-group-wrapper type-"
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + " "
    + alias2(alias1((depth0 != null ? depth0.classes : depth0), depth0))
    + ((stack1 = helpers["if"].call(alias3,(data && data.first),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,(data && data.last),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n						<label class=\"form-label\" for=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.label : depth0), depth0))
    + "</label>\n						<div class=\"form-input-wrapper\">\n"
    + ((stack1 = container.invokePartial(partials["form-input"],depth0,{"name":"form-input","data":data,"indent":"\t\t\t\t\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "						</div>\n					</div><!-- display inline-block space fix\n				-->";
},"12":function(container,depth0,helpers,partials,data) {
    return " first";
},"14":function(container,depth0,helpers,partials,data) {
    return " last";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "				<div class=\"form-input-wrapper\">\n					<textarea rows=\"5\" id=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.id : stack1), depth0))
    + "\" name=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.name : stack1), depth0))
    + "\" class=\"form-textarea "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.classes : stack1), depth0))
    + "\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.placeholder : stack1), depth0))
    + "\""
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.required : stack1),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.maxlength : stack1),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.minlength : stack1),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.value : stack1),{"name":"if","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</textarea>\n				</div>\n";
},"17":function(container,depth0,helpers,partials,data) {
    return " required";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " maxlength=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.maxlength : stack1), depth0))
    + "\"";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " minlength=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.minlength : stack1), depth0))
    + "\"";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.textarea : depth0)) != null ? stack1.value : stack1), depth0));
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "				<div class=\"form-input-wrapper "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.button : depth0)) != null ? stack1.classes : stack1), depth0))
    + "\">\n					<button>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.button : depth0)) != null ? stack1.value : stack1), depth0))
    + "</button>\n				</div>\n";
},"27":function(container,depth0,helpers,partials,data) {
    return "<div class=\"form-spacer\">&nbsp;</div>";
},"29":function(container,depth0,helpers,partials,data) {
    return "<hr/>";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<form class=\"row form-container\" action=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["0"] : depth0)) != null ? stack1.action : stack1), depth0))
    + "\" method="
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["0"] : depth0)) != null ? stack1.method : stack1), depth0))
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0["0"] : depth0)) != null ? stack1.enctype : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "><!-- display inline-block space fix\n				\n-->"
    + ((stack1 = helpers.each.call(alias3,depth0,{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<!-- display inline-block space fix\n				\n--></form>";
},"usePartial":true,"useData":true});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "			<li class=\"feature-item col "
    + container.escapeExpression(((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper)))
    + ((stack1 = helpers["if"].call(alias1,(data && data.first),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(data && data.last),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.feature_img : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.feature_title : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.feature_text : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.feature_description : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.feature_cta : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "			</li>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " first";
},"4":function(container,depth0,helpers,partials,data) {
    return " last";
},"6":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "					<img src=\""
    + alias4(((helper = (helper = helpers.feature_img || (depth0 != null ? depth0.feature_img : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_img","hash":{},"data":data}) : helper)))
    + "\" class=\"feature-image img-responsive "
    + alias4(((helper = (helper = helpers.feature_img_classes || (depth0 != null ? depth0.feature_img_classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_img_classes","hash":{},"data":data}) : helper)))
    + "\">\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "					<h3 class=\"feature-title "
    + container.escapeExpression(((helper = (helper = helpers.feature_title_classes || (depth0 != null ? depth0.feature_title_classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_title_classes","hash":{},"data":data}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.feature_title || (depth0 != null ? depth0.feature_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h3>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "					<p class=\"feature-text "
    + container.escapeExpression(((helper = (helper = helpers.feature_text_classes || (depth0 != null ? depth0.feature_text_classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_text_classes","hash":{},"data":data}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.feature_text || (depth0 != null ? depth0.feature_text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "					<p class=\"feature-description "
    + container.escapeExpression(((helper = (helper = helpers.feature_description_classes || (depth0 != null ? depth0.feature_description_classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_description_classes","hash":{},"data":data}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.feature_description || (depth0 != null ? depth0.feature_description : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_description","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.feature_url : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.program(17, data, 0),"data":data})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "						<a class=\"feature-cta "
    + alias4(((helper = (helper = helpers.feature_cta_classes || (depth0 != null ? depth0.feature_cta_classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_cta_classes","hash":{},"data":data}) : helper)))
    + "\" href=\""
    + alias4(((helper = (helper = helpers.feature_url || (depth0 != null ? depth0.feature_url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_url","hash":{},"data":data}) : helper)))
    + "\">\n							<span>"
    + ((stack1 = ((helper = (helper = helpers.feature_cta || (depth0 != null ? depth0.feature_cta : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_cta","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n						</a>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "						<div class=\"feature-cta "
    + container.escapeExpression(((helper = (helper = helpers.feature_cta_classes || (depth0 != null ? depth0.feature_cta_classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_cta_classes","hash":{},"data":data}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.feature_cta || (depth0 != null ? depth0.feature_cta : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feature_cta","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n<div class=\"feature-list-container\">\n	<ul class=\"feature-list row\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</ul>\n</div>\n";
},"useData":true});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "<div id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"map-full-width\"\n	data-api-key=\""
    + alias4(((helper = (helper = helpers.api_key || (depth0 != null ? depth0.api_key : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"api_key","hash":{},"data":data}) : helper)))
    + "\"\n	data-place-title=\""
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "\"\n	data-place-lat=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.place : depth0)) != null ? stack1.lat : stack1), depth0))
    + "\"\n	data-place-lng=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.place : depth0)) != null ? stack1.lng : stack1), depth0))
    + "\"\n	data-center-lat=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.center : depth0)) != null ? stack1.lat : stack1), depth0))
    + "\"\n	data-center-lng=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.center : depth0)) != null ? stack1.lng : stack1), depth0))
    + "\"\n	>\n\n</div>\n";
},"useData":true});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "		<li class=\"slider-item "
    + alias4(((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper)))
    + "\">\n			<div class=\""
    + alias4(((helper = (helper = helpers.wrapper_classes || (depth0 != null ? depth0.wrapper_classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"wrapper_classes","hash":{},"data":data}) : helper)))
    + "\">\n				<div class=\"slider-caption\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n			</div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.image_src : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		</li>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "				<img class=\"slider-background img-responsive hide-mobile\" src=\""
    + alias4(((helper = (helper = helpers.image_src || (depth0 != null ? depth0.image_src : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"image_src","hash":{},"data":data}) : helper)))
    + "\" alt=\"\">\n				<img class=\"slider-background img-responsive hide-desktop\" src=\""
    + alias4(((helper = (helper = helpers.image_src_mobile || (depth0 != null ? depth0.image_src_mobile : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"image_src_mobile","hash":{},"data":data}) : helper)))
    + "\" alt=\"\">\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "		<li class=\"slider-index "
    + ((stack1 = helpers["if"].call(alias1,(data && data.first),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-index=\""
    + container.escapeExpression(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\">&nbsp;</li>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "active";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"slider-container\">\n	<ul class=\"slider slider-items-container\">\n"
    + ((stack1 = helpers.each.call(alias1,depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</ul>\n	<ul class=\"slider-paginator text-center\">\n"
    + ((stack1 = helpers.each.call(alias1,depth0,{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</ul>\n</div>";
},"useData":true});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<footer class=\"site-footer\">\n	<div class=\"content-wrapper\">\n		<div class=\"row\">\n			<div class=\" col vertical-center\">\n				<p class=\"text-right\">"
    + container.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data}) : helper)))
    + "</p>\n			</div>\n		</div>\n	</div>\n</footer>";
},"useData":true});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "			<li>\n				<a class=\"action-menu-link\" href=\""
    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
    + "\">"
    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "</a>\n			</li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<header class=\"row site-header\">\n	<div class=\"content-wrapper relative row full\">\n		<div class=\"col col-force vertical-center\">\n			<a href=\"#home\" class=\"home-link\">\n				<img class=\"logo img-responsive\" alt=\"logo\" src=\""
    + alias4(((helper = (helper = helpers.logo_src || (depth0 != null ? depth0.logo_src : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"logo_src","hash":{},"data":data}) : helper)))
    + "\">\n			</a>\n		</div>\n		\n		<div class=\"text-right col col-force vertical-center\">\n			<a href=\"#\" class=\"open-menu\">\n				<img class=\"action-menu \" src=\""
    + alias4(((helper = (helper = helpers.menu_src || (depth0 != null ? depth0.menu_src : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"menu_src","hash":{},"data":data}) : helper)))
    + "\">\n			</a>\n		</div>\n	</div>\n</header>\n\n<nav class=\"site-menu\">\n	<ul class=\"site-menu-dropdown text-right active\">\n		<li class=\"site-menu-close\">\n			<a href=\"#\" class=\"close-menu\">\n				<img class=\"action-menu\" src=\""
    + alias4(((helper = (helper = helpers.close_src || (depth0 != null ? depth0.close_src : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"close_src","hash":{},"data":data}) : helper)))
    + "\">\n			</a>\n		</li>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.nav : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</ul>\n</nav>";
},"useData":true});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "		<div class=\"site-block relative highlight-panel "
    + alias4(((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper)))
    + "\">\n			<img class=\"decoration\" src=\""
    + alias4(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\" alt=\"\">\n			<h2>"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h2>\n			<div class=\"description\">"
    + ((stack1 = ((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n		</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"content-wrapper site-block\">\n	<h1>"
    + container.escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "</h1>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.content : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"highlight-panel\">\n	<div class=\"content-wrapper row\">\n		<div class=\"col contact-data site-block\">\n			<h1>"
    + container.escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data}) : helper)))
    + "</h1>\n"
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.list_data : depth0),{"name":"list","data":data,"indent":"\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "		</div>\n		<div class=\"col contact-map-cont\">\n"
    + ((stack1 = container.invokePartial(partials.map,(depth0 != null ? depth0.map_data : depth0),{"name":"map","data":data,"indent":"\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "		</div>\n	</div>\n</div>\n\n\n<div class=\"site-block content-wrapper\">\n	<p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? depth0.contact_form : depth0)) != null ? stack1.title : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n"
    + ((stack1 = container.invokePartial(partials.form,((stack1 = (depth0 != null ? depth0.contact_form : depth0)) != null ? stack1.contact_data : stack1),{"name":"form","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"content-wrapper site-block\">\n	<h1>"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h1>\n	<p>"
    + ((stack1 = ((helper = (helper = helpers.caption || (depth0 != null ? depth0.caption : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"caption","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n</div>\n<div class=\"content-wrapper site-block\">\n"
    + ((stack1 = container.invokePartial(partials.form,(depth0 != null ? depth0.candidate_data : depth0),{"name":"form","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n\n<div class=\"content-wrapper text-center\">\n	<small class=\"text-center\"><em>"
    + ((stack1 = ((helper = (helper = helpers.disclaimer || (depth0 != null ? depth0.disclaimer : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"disclaimer","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</em></small>\n	<p>&nbsp;</p>\n</div>";
},"usePartial":true,"useData":true});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"content-wrapper site-block\">\n	<h1>"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h1>\n	<p>"
    + ((stack1 = ((helper = (helper = helpers.caption || (depth0 != null ? depth0.caption : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"caption","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n</div>\n<div class=\"content-wrapper site-block\">\n"
    + ((stack1 = container.invokePartial(partials.form,(depth0 != null ? depth0.investigator_data : depth0),{"name":"form","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n\n<div class=\"content-wrapper text-center\">\n	<small class=\"text-center\"><em>"
    + ((stack1 = ((helper = (helper = helpers.disclaimer || (depth0 != null ? depth0.disclaimer : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"disclaimer","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</em></small>\n	<p>&nbsp;</p>\n</div>";
},"usePartial":true,"useData":true});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"billboard\">\n"
    + ((stack1 = container.invokePartial(partials.slider,(depth0 != null ? depth0.billboard : depth0),{"name":"slider","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n\n<div id=\"why_rs\" class=\"site-block home-why-rs content-wrapper scroll-event\">\n"
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.why_resolution_block : depth0),{"name":"list","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n\n<div id=\"why_la\" class=\"site-block home-why-la content-wrapper scroll-event\">\n"
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.why_la_block : depth0),{"name":"list","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n\n<div id=\"our_services\" class=\"site-block home-our-services content-wrapper scroll-event\">\n	<h2>"
    + alias4(((helper = (helper = helpers.our_services_title || (depth0 != null ? depth0.our_services_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"our_services_title","hash":{},"data":data}) : helper)))
    + "</h2>\n	<div class=\"fix-padded-width\">\n"
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.our_services_items : depth0),{"name":"list","data":data,"indent":"\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n	</div>\n</div>\n\n<div id=\"about_us\" class=\"site-block home-about-us content-wrapper scroll-event\">\n	<h2>"
    + alias4(((helper = (helper = helpers.about_us_title || (depth0 != null ? depth0.about_us_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"about_us_title","hash":{},"data":data}) : helper)))
    + "</h2>\n	<div class=\"fix-padded-width\">\n"
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.about_us_items : depth0),{"name":"list","data":data,"indent":"\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	</div>\n</div>\n\n<div id=\"contact_us\" class=\"site-block home-map scroll-event content-wrapper\">\n	<h2>"
    + alias4(((helper = (helper = helpers.contact_us_title || (depth0 != null ? depth0.contact_us_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"contact_us_title","hash":{},"data":data}) : helper)))
    + "</h2>\n	<div class=\"relative\">\n		<div class=\"contact-us-description\">\n			"
    + ((stack1 = ((helper = (helper = helpers.contact_us_description || (depth0 != null ? depth0.contact_us_description : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"contact_us_description","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n			<div class=\"text-right\">\n				<a href=\""
    + alias4(((helper = (helper = helpers.contact_us_url || (depth0 != null ? depth0.contact_us_url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"contact_us_url","hash":{},"data":data}) : helper)))
    + "\">"
    + alias4(((helper = (helper = helpers.contact_us_cta || (depth0 != null ? depth0.contact_us_cta : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"contact_us_cta","hash":{},"data":data}) : helper)))
    + "</a>\n			</div>\n		</div>\n	</div>\n"
    + ((stack1 = container.invokePartial(partials.map,(depth0 != null ? depth0.map_data : depth0),{"name":"map","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "		<li><span class=\""
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" data-class=\""
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span></li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "		<div class=\"services "
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n			<div class=\"billboard row\">\n				<div class=\"col relative backimg\">\n					<h3 class=\"title\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h3>\n				</div>\n				<div class=\"col relative description\">\n					<span class=\"arrow\" data-class=\""
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></span>\n					<p class=\"half\">"
    + ((stack1 = ((helper = (helper = helpers.half || (depth0 != null ? depth0.half : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"half","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n					<p class=\"full\">"
    + ((stack1 = ((helper = (helper = helpers.full || (depth0 != null ? depth0.full : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"full","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n				</div>\n			</div>\n			\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.modules : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.extra : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "			<div class=\"row modules child "
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.modules : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "			</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "				<div class=\"relative module\">\n					<h4 class=\"title\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</h4>\n					<span class=\"arrow\" data-class=\""
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></span>\n					<p class=\""
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n				</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "			<div class=\"row extra child "
    + ((stack1 = ((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"classes","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\">\n				<p>"
    + ((stack1 = ((helper = (helper = helpers.extra || (depth0 != null ? depth0.extra : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"extra","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n			</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"content-wrapper site-block\">\n	<h1>"
    + container.escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "</h1>\n	<ul class=\"menu\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.menu : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</ul>\n	<div class=\"main-content\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.content : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</div>\n</div>\n";
},"useData":true});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"content-wrapper site-block\">\n"
    + ((stack1 = container.invokePartial(partials.form,(depth0 != null ? depth0.form : depth0),{"name":"form","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=helpers.helperMissing, alias5="function";

  return "<div class=\"billboard highlight-panel\">\n	<div class=\"content-wrapper row\">\n		<div class=\"col\">\n			<h1>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.billboard : depth0)) != null ? stack1.title : stack1), depth0))
    + "</h1>\n			<p>"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.billboard : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n		</div>\n		<div class=\"col\">\n			<img class=\"img-responsive\" src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.billboard : depth0)) != null ? stack1.src : stack1), depth0))
    + "\">\n		</div>\n	</div>\n</div>\n\n<div class=\"advantages content-wrapper site-block\">\n	<h1>"
    + alias2(((helper = (helper = helpers.advantages_title || (depth0 != null ? depth0.advantages_title : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"advantages_title","hash":{},"data":data}) : helper)))
    + "</h1>\n"
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.advantages_1 : depth0),{"name":"list","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.advantages_2 : depth0),{"name":"list","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n\n<div class=\"closure-text content-wrapper\">\n	<p>"
    + ((stack1 = ((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"description","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n	<p class=\"legend\"><em>"
    + ((stack1 = ((helper = (helper = helpers.legend || (depth0 != null ? depth0.legend : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"legend","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</em></p>\n</div>";
},"usePartial":true,"useData":true});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=helpers.helperMissing, alias5="function";

  return "<div class=\"billboard highlight-panel\">\n	<div class=\"content-wrapper row\">\n		<div class=\"col\">\n			<h1>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.billboard : depth0)) != null ? stack1.title : stack1), depth0))
    + "</h1>\n			<p>"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.billboard : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n		</div>\n		<div class=\"col\">\n			<img class=\"img-responsive\" src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.billboard : depth0)) != null ? stack1.src : stack1), depth0))
    + "\">\n		</div>\n	</div>\n</div>\n\n<div class=\"advantages content-wrapper site-block\">\n	<p>"
    + alias2(((helper = (helper = helpers.caption || (depth0 != null ? depth0.caption : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"caption","hash":{},"data":data}) : helper)))
    + "</p>\n"
    + ((stack1 = container.invokePartial(partials.list,(depth0 != null ? depth0.why : depth0),{"name":"list","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n\n<div class=\"content-wrapper row ruler-container\">\n	<div class=\"ruler\"></div>\n</div>\n\n<div class=\"closure-text content-wrapper row\">\n	<div>\n		<p>"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n	</div>\n</div>";
},"usePartial":true,"useData":true});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(0);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(container.lambda((depth0 != null ? depth0.template : depth0), depth0))
    + ",";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "		<div id=\"popup-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" class=\"site-popup "
    + alias2(alias1((depth0 != null ? depth0.classes : depth0), depth0))
    + "\">\n			"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.close_src : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n			"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.html : stack1), depth0)) != null ? stack1 : "")
    + "\n		</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "<img class=\"popup-close\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.close_src : depth0), depth0))
    + "\">";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	<script id=\"template-"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.template : depth0), depth0))
    + "\" type=\"text/x-handlebars-template\">\n"
    + ((stack1 = container.invokePartial(helpers.lookup.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"template",{"name":"lookup","hash":{},"data":data}),(depth0 != null ? depth0.data : depth0),{"data":data,"indent":"\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	</script>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = container.invokePartial(partials.header,(depth0 != null ? depth0.header : depth0),{"name":"header","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<input type=\"hidden\" id=\"validTemplates\" name=\"\" value=\""
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.pages : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n<main role=\"main\" class=\"site-content\">\n\n\n</main>\n\n<div id=\"popup-overlay\" class=\"popup-overlay\">\n	<div class=\"popups-wrapper\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.popups : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</div>\n</div>\n\n\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.pages : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(partials.footer,(depth0 != null ? depth0.footer : depth0),{"name":"footer","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = __webpack_require__(4);

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = __webpack_require__(51);

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = __webpack_require__(2);

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = __webpack_require__(1);

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = __webpack_require__(50);

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = __webpack_require__(49);

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = __webpack_require__(39);

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG5cbiJdfQ==


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(1);

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXFCLFVBQVU7O3FCQUVoQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7ZXh0ZW5kfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVyRGVjb3JhdG9yKCdpbmxpbmUnLCBmdW5jdGlvbihmbiwgcHJvcHMsIGNvbnRhaW5lciwgb3B0aW9ucykge1xuICAgIGxldCByZXQgPSBmbjtcbiAgICBpZiAoIXByb3BzLnBhcnRpYWxzKSB7XG4gICAgICBwcm9wcy5wYXJ0aWFscyA9IHt9O1xuICAgICAgcmV0ID0gZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgICAgICAvLyBDcmVhdGUgYSBuZXcgcGFydGlhbHMgc3RhY2sgZnJhbWUgcHJpb3IgdG8gZXhlYy5cbiAgICAgICAgbGV0IG9yaWdpbmFsID0gY29udGFpbmVyLnBhcnRpYWxzO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBleHRlbmQoe30sIG9yaWdpbmFsLCBwcm9wcy5wYXJ0aWFscyk7XG4gICAgICAgIGxldCByZXQgPSBmbihjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgICAgY29udGFpbmVyLnBhcnRpYWxzID0gb3JpZ2luYWw7XG4gICAgICAgIHJldHVybiByZXQ7XG4gICAgICB9O1xuICAgIH1cblxuICAgIHByb3BzLnBhcnRpYWxzW29wdGlvbnMuYXJnc1swXV0gPSBvcHRpb25zLmZuO1xuXG4gICAgcmV0dXJuIHJldDtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = __webpack_require__(41);

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = __webpack_require__(42);

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = __webpack_require__(43);

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = __webpack_require__(44);

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = __webpack_require__(45);

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = __webpack_require__(46);

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = __webpack_require__(47);

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7eUNBQXVDLGdDQUFnQzs7OzsyQkFDOUMsZ0JBQWdCOzs7O29DQUNQLDBCQUEwQjs7Ozt5QkFDckMsY0FBYzs7OzswQkFDYixlQUFlOzs7OzZCQUNaLGtCQUFrQjs7OzsyQkFDcEIsZ0JBQWdCOzs7O0FBRWxDLFNBQVMsc0JBQXNCLENBQUMsUUFBUSxFQUFFO0FBQy9DLHlDQUEyQixRQUFRLENBQUMsQ0FBQztBQUNyQywyQkFBYSxRQUFRLENBQUMsQ0FBQztBQUN2QixvQ0FBc0IsUUFBUSxDQUFDLENBQUM7QUFDaEMseUJBQVcsUUFBUSxDQUFDLENBQUM7QUFDckIsMEJBQVksUUFBUSxDQUFDLENBQUM7QUFDdEIsNkJBQWUsUUFBUSxDQUFDLENBQUM7QUFDekIsMkJBQWEsUUFBUSxDQUFDLENBQUM7Q0FDeEIiLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCByZWdpc3RlckJsb2NrSGVscGVyTWlzc2luZyBmcm9tICcuL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcnO1xuaW1wb3J0IHJlZ2lzdGVyRWFjaCBmcm9tICcuL2hlbHBlcnMvZWFjaCc7XG5pbXBvcnQgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nIGZyb20gJy4vaGVscGVycy9oZWxwZXItbWlzc2luZyc7XG5pbXBvcnQgcmVnaXN0ZXJJZiBmcm9tICcuL2hlbHBlcnMvaWYnO1xuaW1wb3J0IHJlZ2lzdGVyTG9nIGZyb20gJy4vaGVscGVycy9sb2cnO1xuaW1wb3J0IHJlZ2lzdGVyTG9va3VwIGZyb20gJy4vaGVscGVycy9sb29rdXAnO1xuaW1wb3J0IHJlZ2lzdGVyV2l0aCBmcm9tICcuL2hlbHBlcnMvd2l0aCc7XG5cbmV4cG9ydCBmdW5jdGlvbiByZWdpc3RlckRlZmF1bHRIZWxwZXJzKGluc3RhbmNlKSB7XG4gIHJlZ2lzdGVyQmxvY2tIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJFYWNoKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJJZihpbnN0YW5jZSk7XG4gIHJlZ2lzdGVyTG9nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJMb29rdXAoaW5zdGFuY2UpO1xuICByZWdpc3RlcldpdGgoaW5zdGFuY2UpO1xufVxuIl19


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(1);

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(1);

var _exception = __webpack_require__(2);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else {
        var priorKey = undefined;

        for (var key in context) {
          if (context.hasOwnProperty(key)) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          }
        }
        if (priorKey !== undefined) {
          execIteration(priorKey, i - 1, true);
        }
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = __webpack_require__(2);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFBYyxtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLENBQUM7S0FDdkY7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ01pc3NpbmcgaGVscGVyOiBcIicgKyBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdLm5hbWUgKyAnXCInKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(1);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ2xCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM5QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVMsSUFBSSxDQUFDLENBQUM7R0FDeEIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgICBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBmb3IgKGxldCBpID0gMDsgaSA8IGFyZ3VtZW50cy5sZW5ndGggLSAxOyBpKyspIHtcbiAgICAgIGFyZ3MucHVzaChhcmd1bWVudHNbaV0pO1xuICAgIH1cblxuICAgIGxldCBsZXZlbCA9IDE7XG4gICAgaWYgKG9wdGlvbnMuaGFzaC5sZXZlbCAhPSBudWxsKSB7XG4gICAgICBsZXZlbCA9IG9wdGlvbnMuaGFzaC5sZXZlbDtcbiAgICB9IGVsc2UgaWYgKG9wdGlvbnMuZGF0YSAmJiBvcHRpb25zLmRhdGEubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmRhdGEubGV2ZWw7XG4gICAgfVxuICAgIGFyZ3NbMF0gPSBsZXZlbDtcblxuICAgIGluc3RhbmNlLmxvZyguLi4gYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field) {
    return obj && obj[field];
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFO0FBQ3JELFdBQU8sR0FBRyxJQUFJLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQztHQUMxQixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJsb29rdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignbG9va3VwJywgZnVuY3Rpb24ob2JqLCBmaWVsZCkge1xuICAgIHJldHVybiBvYmogJiYgb2JqW2ZpZWxkXTtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(1);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(1);

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      if (!console[method]) {
        // eslint-disable-line no-console
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* global window */


exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOztBQUVsQyxNQUFJLElBQUksR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLEdBQUcsTUFBTSxHQUFHLE1BQU07TUFDdEQsV0FBVyxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUM7O0FBRWxDLFlBQVUsQ0FBQyxVQUFVLEdBQUcsWUFBVztBQUNqQyxRQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssVUFBVSxFQUFFO0FBQ2xDLFVBQUksQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQy9CO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIHdpbmRvdyAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oSGFuZGxlYmFycykge1xuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICBsZXQgcm9vdCA9IHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnID8gZ2xvYmFsIDogd2luZG93LFxuICAgICAgJEhhbmRsZWJhcnMgPSByb290LkhhbmRsZWJhcnM7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIEhhbmRsZWJhcnMubm9Db25mbGljdCA9IGZ1bmN0aW9uKCkge1xuICAgIGlmIChyb290LkhhbmRsZWJhcnMgPT09IEhhbmRsZWJhcnMpIHtcbiAgICAgIHJvb3QuSGFuZGxlYmFycyA9ICRIYW5kbGViYXJzO1xuICAgIH1cbiAgICByZXR1cm4gSGFuZGxlYmFycztcbiAgfTtcbn1cbiJdfQ==

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = __webpack_require__(1);

var Utils = _interopRequireWildcard(_utils);

var _exception = __webpack_require__(2);

var _exception2 = _interopRequireDefault(_exception);

var _base = __webpack_require__(4);

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision !== currentRevision) {
    if (compilerRevision < currentRevision) {
      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
    } else {
      // Use the embedded version info since the runtime doesn't know about this revision yet
      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
    }
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as psuedo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }

    partial = env.VM.resolvePartial.call(this, partial, context, options);
    var result = env.VM.invokePartial.call(this, partial, context, options);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, options);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name) {
      if (!(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
      }
      return obj[name];
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        if (depths[i] && depths[i][name] != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    merge: function merge(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }
    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }
  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      container.helpers = container.merge(options.helpers, env.helpers);

      if (templateSpec.usePartial) {
        container.partials = container.merge(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = container.merge(options.decorators, env.decorators);
      }
    } else {
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data);
      // Wrapper function to get access to currentPartialBlock from the closure
      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.
        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Build out our basic SafeString type


exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ }),
/* 52 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sameHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);

function sameHeight(elem, callback) {
	var max;

	function setSize() {
		// reset max
		max = 0;

		// firs remove styles or previous applied size
		[].forEach.call(elem, function(elem) {
			elem.style.height = null;
		});

		// get natural height
		[].forEach.call(elem, function(elem) {
			max = Math.max(max, elem.offsetHeight);

		});

		// set height of max elem
		[].forEach.call(elem, function(elem) {
			elem.style.height = max + "px";

		});
	}
	if (elem[0].getAttribute("data-same-height-enabled") === "true") {
		setSize();
		return;
	}

	setSize();
	elem[0].setAttribute("data-same-height-enabled", "true");
	window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* throttle */](setSize, 400));

}

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);

function scrollPosition(elem, config) {
	var config = config || {};
	var wheight = window.innerHeight;
	var offset = config.offset || 2;
	var callback = config.callback || function () {};

	function scrollFired() {
		wheight = window.innerHeight;
		getScrollPosition();
	}

	window.addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* throttle */](scrollFired, 150));
	window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* throttle */](scrollFired, 400));

	function getScrollPosition(){
		for (var i = 0; i < elem.length; i++) {
			var elemTop = elem[i].getBoundingClientRect().top;
			if (elemTop > 0 && elemTop < wheight / 2) {
				callback({index: i});
				return; // found first then stop
			}
		}
	}
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_site_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_site_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__css_site_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detection_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detection_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__detection_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_hyperform_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_hyperform_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vendor_hyperform_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__templates__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metrics__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_slider__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_home__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_contact_us__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_our_services__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_about_us__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_test__ = __webpack_require__(15);





window.DEBUG = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getParameter */]("debug");
















var siteWeb = function () {
	this.build();
	this.initialize();
};

siteWeb.prototype.build = function () {
	var self = this;
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__templates__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* getLocale */](), function () {
		self.bindings();
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__metrics__["a" /* default */])();
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_forms__["a" /* default */])();
	});
}

siteWeb.prototype.getHash = function (full) {
	var tmp = window.location.hash.split("#")[1];
	if (tmp) {
		if (full) {
			return tmp;
		} else {
			return tmp.split("&")[0];
		}
	}
	return tmp;
};

siteWeb.prototype.getHashParam = function (id) {
	var hash = this.getHash(true),
		params = [],
		returnValue,
		returnObject;

	if (hash) {
		params = hash.split("&");
		if (params.length) {
			if (!id) {
				return params.splice(1, params.length);
			} else {
				params.forEach(function (value, index) {
					// first value is hash! #&param1=foo&param2=bar
					if (index > 0) {
						if (value.split("=")[0] === id) {
							returnValue = value.split("=")[1];
						}
					}
				});
			}
			
		}
	} else {
		returnValue = false;
	}

	return returnValue
};

siteWeb.prototype.setHashParam = function (param) {
	var hash = this.getHash(true), params, tmpObj = {};

	// TODO sin terminar
	/*if (hash && param) {
		params = hash.split("&").splice(1, params.length);// removed hash
		if (params.length) {

			params.forEach(function (value, index) {
				// first value is hash! #&param1=foo&param2=bar
				if (index > 0) {
					if (value.split("=")[0] === id) {
						returnValue = value.split("=")[1];
					}
				}
			});
		}
			
	}*/
};

siteWeb.prototype.clearHashParams = function () {
	var hash = this.getHash();
	if (!hash && history) {
		history.pushState("", document.title, window.location.pathname + window.location.search);
		return;
	} else if (!hash) {
		hash = "";
	}
	window.location.hash = hash;
}

siteWeb.prototype.initialize = function () {
	var self = this, hash, hashParam;

	this.validTemplates = document.querySelector("#validTemplates").value.split(",");

	hash = this.getHash() || "home";
	//hashParam = this.getHashParam();
	this.prevView = Math.random() + "";
	this.loadView(hash);

	// dynamic template loading 
	window.onhashchange = function () {
		self.loadView(self.getHash());
	};
};

siteWeb.prototype.reloadActive = function () {
	var hash, elem, self = this;
	hash = self.getHash();
	elem = document.querySelector(".site-menu li a[href='#" + hash + "']");
	if (hash && elem) {
		elem.classList.add("active");
	}
};

siteWeb.prototype.removeActive = function () {
	var links = document.querySelectorAll(".site-menu li a");
	[].forEach.call(links, function(link) {
		link.classList.remove("active");
	});
};

siteWeb.prototype.bindings = function () {
	var self = this;
	var links = document.querySelectorAll(".site-menu-dropdown a");

	document.querySelector(".site-menu").onclick = function (e) {
		if (e.target.nodeName === "A" && e.target.classList.contains("action-menu-link")) {
			[].forEach.call(document.querySelectorAll(".site-menu-dropdown a"), function(el) {
				el.classList.remove("active");
			});
			e.target.classList.add("active");
		} else {
			if ( e.target.classList.contains("action-menu") || e.target.classList.contains("close-menu") ) {
				// nothing
			} else {
				e.stopPropagation();
			}
		}
	}

	document.querySelector(".close-menu").onclick = function (e) {
		e.preventDefault();
	}	

	document.querySelector(".open-menu").onclick = function (e) {
		e.preventDefault();
		e.stopPropagation();
		document.querySelector("html").classList.add("menu-open");
	}

	document.onclick = function (e) {
		document.querySelector("html").classList.remove("menu-open");
	}

	document.querySelector(".popups-wrapper").onclick = function (e) {
		if (!e.target.classList.contains("popup-close")) {
			e.stopPropagation();
		}
	}

	document.querySelector("#popup-overlay").onclick = function () {
		self.hidePopups();
	}

	window.onsubmit = function () {
		self.showPopup("loading");
	}
}

siteWeb.prototype.loadView = function (the_view) {
	var section, targetView, popup = this.getHashParam("popup");

	// check for popups
	if (popup) {
		this.showPopup(popup);
	}

	if (/*!the_view || */the_view === this.prevView) {
		return;
	}

	//if (!this.validTemplates.includes(the_view)) {
	if (this.validTemplates.indexOf(the_view) === -1) {
		DEBUG && console.error("[APP] Template data not found in JSON file!");
		the_view = "home";
		//return;
	}


	[].forEach.call(document.querySelectorAll("[role='main'] > section"), function(section) {
		section.classList.remove("active");
	});

	targetView = document.querySelector("[role='main'] > section." + the_view);

	if (targetView) {
		targetView.classList.add("active");
	} else {
		targetView = document.createElement('section');
		targetView.classList.add(the_view);
		targetView.classList.add("active");
		targetView.innerHTML = document.querySelector("#template-" + the_view).innerHTML;

		document.querySelector("[role='main']").appendChild(targetView);
		//document.querySelector("#template-" + the_view).remove();
	}

	// helper para css mas que nada
	document.querySelector("body").setAttribute("data-page", the_view);
	this.onChangeView(the_view);
	this.prevView = the_view;
	this.removeActive();
	this.reloadActive();
};

siteWeb.prototype.showPopup = function (id) {
	var elem = document.querySelector("#popup-" + id);

	if (!id || !elem) {
		return;
	}

	document.querySelector(".popup-overlay").classList.add("active");
	[].forEach.call(document.querySelectorAll(".site-popup"), function(popup) {
		popup.classList.remove("active");
	});
	
	elem.classList.add("active");
};

siteWeb.prototype.hidePopups = function () {
	[].forEach.call(document.querySelectorAll(".site-popup"), function(popup) {
		popup.classList.remove("active");
	});

	this.clearHashParams();
	document.querySelector(".popup-overlay").classList.remove("active");
};

siteWeb.prototype.onChangeView = function (the_view) {
	window.scrollTo(0, 0);

	// apply slider all views
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_slider__["a" /* default */])(document.querySelectorAll(".slider"), {
		timer: 4000,
		speed: 900
	});

	if (the_view === "home") {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__pages_home__["a" /* default */])(this.getHashParam("action"));
	} else if (the_view === "contact_us") {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__pages_contact_us__["a" /* default */])(this.getHashParam("action"));
	} else if (the_view === "our_services") {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__pages_our_services__["a" /* default */])(this.getHashParam("action"));
	} else if (the_view === "about_us") {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__pages_about_us__["a" /* default */])(this.getHashParam("action"));
	}

	this.clearHashParams();
};

new siteWeb;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = {"config":{},"header":{"logo_src":"images/logo.svg","menu_src":"images/menu.svg","close_src":"images/close.svg","nav":[{"text":"Why Resolution?","url":"#why_rs"},{"text":"Why Latin America?","url":"#why_la"},{"text":"Our Services","url":"#our_services"},{"text":"About Us","url":"#about_us"},{"text":"Contact Us","url":"#contact_us"}]},"footer":{"text":"© Copyright 2018 - All Right Reserved - ReSolution Latin America"},"popups":[{"id":"done","classes":"notice","close_src":"images/close.svg","data":{"html":"<img style='max-width: 12em; margin-top: 1em; margin-bottom: 2.5em;' src='images/logo.svg'><h1>Thanks for submitting the form!</h1>"}},{"id":"error","classes":"notice","close_src":"images/close.svg","data":{"html":"<img style='max-width: 12em; margin-top: 1em; margin-bottom: 2.5em;' src='images/logo.svg'><h1>An error occurred, please try again!</h1>"}},{"id":"loading","classes":"stopPropagation","data":{"html":"<img src='images/spinner.gif'>"}}],"pages":[{"template":"test","data":{"form":[{"label":"NAME (required):","id":"","name":"","input":{"type":"text","placeholder":"","required":true}},{"label":"Letters (required):","id":"","name":"","input":{"type":"text","validate":"letters","placeholder":"Solo letras y espacio","required":true}},{"label":"Letters (required):","id":"","name":"","input":{"type":"number","placeholder":"Solo numeros","required":true}},{"label":"URL (required):","id":"","name":"","input":{"type":"url","placeholder":"Solo urls","required":true}},{"label":"NO-SPECIAL (required):","id":"","name":"","input":{"type":"text","validate":"no-special","placeholder":"Solo no specials","required":true}},{"classes":"text-center submit","id":"","button":{"value":"Submit"}}]}},{"template":"home","data":{"billboard":[{"classes":"crs","text":"<strong>Clinical Research Solutions</strong><br> Across Latin America","image_src":"../images/home/slide-1.jpg","image_src_mobile":"../images/home/slide-1_mobile.jpg","wrapper_classes":"content-wrapper relative"},{"classes":"qeia text-center","text":"<div class='style1-container'><strong>Quality / Excellence / integrity / Accountability</strong><br> <div class='relative'><span class='style1'>across Latin America</span></div></div>","image_src":"../images/home/slide-2.jpg","image_src_mobile":"../images/home/slide-2_mobile.jpg","wrapper_classes":"content-wrapper relative"},{"classes":"turned-10","text":"<strong>We've <br>turned 10!</strong> 10 years contributing to our <br>Sponsors' success stories!","image_src":"../images/home/slide-3.jpg","image_src_mobile":"../images/home/slide-3_mobile.jpg","wrapper_classes":"content-wrapper relative"}],"why_resolution_block":[{"classes":"titled-area","feature_title":"<span>Why Resolution?</span>"},{"feature_text":"ReSolution Latin America is a regional-specialized CRO that offers development companies access to all the benefits that the region offers for clinical development.","feature_cta":"> Learn More","feature_url":"#why_rs"}],"why_la_block":[{"classes":"titled-area relative hide-desktop","feature_img":"../images/home/why-latin-america_mobile.jpg","feature_img_classes":"absolute","feature_title":"<span>Why Latin <br>America?</span>"},{"classes":"","feature_text":"Latin America offers tremendous benefits to international clinical studies in terms of enrollment potential, quality data, timelines and costs.","feature_cta":"> Learn More","feature_url":"#why_la"},{"classes":"titled-area relative hide-mobile","feature_img":"../images/home/why-latin-america.jpg","feature_img_classes":"absolute","feature_title":"<span>Why Latin <br>America?</span>"}],"our_services_title":"Our Services","our_services_items":[{"classes":"text-center text-uppercase relative","feature_img":"../images/home/consultancy.jpg","feature_cta":"Consultancy","feature_url":"#our_services&action=consultancy"},{"classes":"text-center text-uppercase relative","feature_img":"../images/home/clinical-management.jpg","feature_cta":"Clinical Management","feature_url":"#our_services&action=clinical"},{"classes":"text-center text-uppercase relative","feature_img":"../images/home/outsourcing.jpg","feature_cta":"outsourcing","feature_url":"#our_services&action=outsourcing"},{"classes":"text-center text-uppercase relative","feature_img":"../images/home/qa.jpg","feature_cta":"Quality Assurance","feature_url":"#our_services&action=qa"}],"about_us_title":"About Us","about_us_items":[{"classes":"text-center","feature_img":"../images/management.svg","feature_title":"MANAGEMENT","feature_description":"Our Management's experience of clinical development transcends the Latin American region, which is an important differentiator and a key success factor.","feature_cta":"> Learn More","feature_url":"#about_us"},{"classes":"text-center","feature_img":"../images/res-net.svg","feature_title":"Res.NET <br><span>(<strong>ReS</strong>olution Investigator <strong>Net</strong>work)</span>","feature_description":"Access the region's premier clinical sites as part of ReSolution's Investigator Network, ResNet.","feature_cta":"> Learn More","feature_url":"#about_us&action=rs"},{"classes":"text-center","feature_img":"../images/join-us.svg","feature_title":"JOIN US","feature_description":"If you are interested in furthering your career in a quality-driven, dynamic and customer-focused company where your input will make a real difference, contact us.","feature_cta":"> Learn More","feature_url":"#about_us&action=join"}],"contact_us_title":"Contact Us","contact_us_description":"Av. Congreso 1534 (3rd Floor) <br>Capital Federal, C1428BUB <br>Buenos Aires, Argentina<br><br>PHONE: +54 11 4784 4710<br>FAX: +54 11 4785 3614","contact_us_cta":"Send Message","contact_us_url":"#contact_us","map_data":{"id":"home-map","place":{"lat":"-34.5509358","lng":"-58.4536052"},"center":{"lat":"-34.5494111","lng":"-58.4650489"},"api_key":"AIzaSyBfZ_sJ5rJZxTNDFA0htFhLmBm0nAgjjPA"}}},{"template":"why_la","data":{"billboard":{"title":"Why Latin America?","text":"The number of drug candidates entering the clinical development phase continues to increase dramatically, bringing with it an increased competition for what is a finite resource of both patients and investigators.<br><br>Considering less “traditional” territories for clinical development programs is now an inescapable reality and it is really no longer feasible to disregard emerging territories. At the same time, these territories can contribute tremendously to virtually any program, not just in terms of aspects such as recruitment, but also of other factors such as timelines, cost and, most importantly, quality.<br><br>Latin America continues to boom as a territory for clinical research thanks to the advantages it offers over more “traditional” territories for clinical research, as well as other emerging territories.","src":"images/why_la.jpg"},"advantages_title":"These advantages include:","advantages_1":[{"feature_description":"<span>1</span><span>Large patient populations (relatively treatment naive) concentrated in urban areas.</span>"},{"feature_description":"<span>2</span><span>Highly qualified medical personnel with experience of clinical research.<br>- Knowledge of ICH-GCP Guidelines.<br>- Eager to participate in clinical trials.</span>"},{"feature_description":"<span>3</span><span>A tradition of Western Medicine.</span>"},{"feature_description":"<span>4</span><span>Stable and well-established regulatory environments.</span>"}],"advantages_2":[{"feature_description":"<span>5</span><span>Similar disease profiles and epidemiology for many diseases to other developed regions.</span>"},{"feature_description":"<span>6</span><span>Lower costs for conducting trials.</span>"},{"feature_description":"<span>7</span><span>Common Language (2 languages covering >600M people).</span>"},{"feature_description":"<span>8</span><span>Inverse seasonality vs. northern hemisphere providing potential for extending the recruitment window for seasonal disorders.</span>"}],"description":"At the same time, there is great regional variability with regards to the maturity of the clinical research industry across the continent and factors such as cultural aspects, working practices, standard of care and attitude towards clinical research can all have important consequences when it comes to conducting trials in the region.","legend":"Understanding and respecting these factors is the key to success in the region."}},{"template":"why_rs","data":{"billboard":{"title":"Why Resolution?","text":"The need for a regional CRO that is able to contribute to international clinical development programs both in terms of recruitment and quality, whilst simultaneously offering the benefits of Latin America for aspects such as cost and timelines, is clear.<br><br>Continued consolidation in the industry by global CROs has made this need more apparent and even more acute. By working with large global CROs, with inflexible one-size-fits-all procedures, global blended rates and disregard of local/regional idiosyncrasies, drug development companies are not able to fully unlock the tremendous potential that Latin America can offer.","src":"images/why_rs.jpg"},"caption":"ReSolution Latin America fills this gap providing development companies, as well as other CROs, the opportunity to work with a credible regional niche CRO provider in Latin America that is able to successfully:","why":[{"feature_description":"<span>1.</span> Understand the expectations of international clients, as well as the requirements and demands of international clinical protocols."},{"feature_description":"<span>2.</span> Work locally and regionally to execute and deliver to these standards."}],"text":"Our ability to understand local/regional idiosyncrasies, as well as our Sponsors’ expectations, makes us a perfect cultural fit and allows us to effectively act as a conduit and facilitator between all parties.<br><br>Our set-up and size makes us agile and efficient. The right Project Team is assembled according to your specific need whilst our scalability and flexibility allows us to react and adapt as your needs evolve.<br><br>Whether you are looking for a long-term partner for your clinical development program in Latin America or are grappling with a particular issue for which you need advice, ReSolution Latin America can help you.<br><br>Having enrolled over 14,500 participants across Latin American to-date, ReSolution continues to play a leading role in our Sponsors´ success stories.<br><br>For some of our Sponsors, we are a Consultancy Company, to others, a CRO. You choose."}},{"template":"about_us","data":{"title":"About Us","content":[{"classes":"mgmt","icon":"images/management.svg","title":"MANAGEMENT - <span>Global Standards, Regional Execution</span>.","description":"ReSolution Latin America’s Management Team brings with it considerable experience in clinical development gained from positions held in prestigious international companies having been based in Europe, the Unites States and Latin America, both in the pharma and CRO industries. We have a successful track record of managing all aspects of the CRO business in Latin America and of implementing a variety of clinical protocols in the region. <br><br>We are united by our commitment to raising the standards of clinical research in Latin America. Our mission is simple enough:<br><br>To offer our clients the highest standards of clinical research in Latin America thereby continuing to make it a territory of choice, not must, for clinical research.<br><br>- Eric Johansson: Managing Director, Business Operations<br>- Ariel Fariña: Managing Director, Clinical Operations"},{"classes":"rs","icon":"images/res-net.svg","title":"ResNET- The ReSolution Investigator Network","description":"ReSolution Latin America has established privileged relationships with leading investigators in various therapeutic areas across the region.<br><br>At the same time, as the number of protocols implemented in the region continues to rise, many sites are nearing or even exceeding capacity. ReSolution Latin America is committed to expanding this list. With active search, and under an umbrella of training and quality, ReSNET is a continually expanding list.<br><br>Sites that participate in our Sponsors’ protocols are carefully evaluated for key aspects such as:<br><br><strong>1- Experience &amp; expertise</strong><br><strong>2- Resources &amp; Facilities</strong><br><strong>3- Commitment &amp; enthusiasm</strong><br><strong>4- IRB standards &amp; approval timelines</strong><br><strong>5- Competing studies</strong><br><strong>6- Enrollment potential</strong><br><br>Effective monitoring and intense site management, coupled with comprehensive Quality Assurance activities, ensure the highest standards of clinical research.<br><br>ReSolution Latin America is continually looking to expand our Investigator Network. If you are interested in participating in our Sponsors’ protocols, please click on the following link: <br><br><a class='link-button' href='#investigator_appl_form'> Investigator Application Form</a>"},{"classes":"join","icon":"images/join-us.svg","title":"join us","description":"At ReSolution Latin America we foster an environment in which everyone strives towards a common goal- the success of the project.<br><br>The type of people that we attract as a Company are people that want to work in a positive, can-do environment in which their contribution makes a real difference. Reward is results-driven and, as such, at ReSolution Latin America everyone is a stakeholder. With autonomy and empowerment comes accountability and only the type of person that thrives on this is the caliber of person that we bring on board.<br><br> If this seems like the type of place you would like to work and if you are interested in joining us, please click on the following link: <br><br><a class='link-button' href='#candidate_appl_form'>Candidate Application Form</a>"}]}},{"template":"contact_us","data":{"title":"Contact Us","list_data":[{"feature_title":"ADDRESS:","feature_description":"Av. Congreso 1534 (3rd Floor)<br>Capital Federal, C1428BUB<br>Buenos Aires, Argentina"},{"feature_title":"Phone:","feature_description":"<a class='tel' href='tel:+541147844710'>+54 11 4784 4710</a>"},{"feature_title":"Fax:","feature_description":"+54 11 4785 3614"},{"feature_title":"ERIC JOHANSSON:","feature_description":"Managing Director, Business Operations<br><a href='mailto:eric.johansson@resolutioncrs.com'>eric.johansson@resolutioncrs.com</a>"},{"feature_title":"ARIEL FARIÑA:","feature_description":"Managing Director, Clinical Operations<br><a href='mailto:ariel.farina@resolutioncrs.com'>ariel.farina@resolutioncrs.com</a>"}],"map_data":{"id":"contact-map","place":{"lat":"-34.5509358","lng":"-58.4536052"},"center":{"lat":"-34.5509358","lng":"-58.4536052"},"api_key":"AIzaSyBfZ_sJ5rJZxTNDFA0htFhLmBm0nAgjjPA"},"contact_form":{"title":"To contact us, please fill in the form below and we will get back to you immediately.","contact_data":[{"action":"http://resolutioncrs.com/services/contact_us.php","method":"post"},{"classes":"form-tile","label":"NAME (required):","input":{"id":"contact_us_name","name":"contact_us_name","type":"text","validate":"letters","placeholder":"","required":true}},{"classes":"form-tile","label":"EMAIL (required):","space-after":true,"input":{"id":"contact_us_email","name":"contact_us_email","type":"email","placeholder":"","required":true}},{"classes":"form-tile","label":"PHONE:","input":{"id":"contact_us_phone","name":"contact_us_phone","type":"tel","placeholder":""}},{"classes":"form-tile","label":"URL:","space-after":true,"input":{"id":"contact_us_url","name":"contact_us_url","type":"url","placeholder":""}},{"classes":"form-block comment-lbl","label":"Comments (please feel free to include any relevant comments):","textarea":{"id":"contact_us_message","name":"contact_us_message","maxlength":"10000"},"hr":{}},{"classes":"text-center submit","id":"submit-contact","input":{"type":"submit","value":"Send Message"}}]}}},{"template":"our_services","data":{"title":"Our Services","menu":[{"classes":"consultancy","title":"Consultancy"},{"classes":"clinical","title":"Clinical Management"},{"classes":"outsourcing","title":"Outsourcing"},{"classes":"qa","title":"Quality Assurance"}],"content":[{"classes":"consultancy","title":"CONSULTANCY SERVICES","image":"../images/home/consultancy_b.jpg","half":"Whether you are considering Latin America as a sole territory for a particular trial, as part of a wider international program or as part of the rescue plan for an ongoing study...","full":"Whether you are considering Latin America as a sole territory for a particular trial, as part of a wider international program or as part of the rescue plan for an ongoing study, ReSolution Latin America can advise and direct you. Our internal expertise supplemented by access to experienced consultants, as well as ReSNET (the ReSolution Investigator NETwork), enables us to offer our Sponsors access to unrivalled expertise.<br><br>Latin America is our niche and we specialize in advising and guiding our Sponsors in the region. We provide expert, unbiased advice ensuring that your clinical development program embarks in the optimal direction. We understand local and regional idiosyncrasies in a region where one size does not fit all.","modules":[{"classes":"clinical","title":"CLINICAL DEVELOPMENT PLANNING","text":"Not all protocols are suitable for Latin America and there is also variability in terms of which countries can participate in a particular protocol. Clearly, there are times when these obstacles cannot be overcome and the region is ruled-out. However, protocols are sometimes ruled-out when, in fact, a bit of lateral thinking can remove these obstacles thereby enabling the region to provide an excellent contribution.<br class='hide-mobile'><br><br>ReSolution Latin America:<br><br>1. Evaluates each client's particular requirements within the context of the goals and timelines of each individual project.<br><br>2. Proactively offers solutions and advice.<br><br>3. Prevents clients from embarking in non-optimal directions."},{"classes":"consultancy","title":"REGULATORY CONSULTANCY","text":"The Regulatory procedures in Latin America can seem complicated and, though the regulatory framework is generally well-defined, it warrants careful and proactive management. A clearly thought-out strategy, seamless execution and effective follow-up all serve to avoid delay.<br><br>Whether your requirement calls for advice and direction on the optimal strategy to be adopted for obtaining regulatory approval to the compilation and submission of the regulatory dossier, ReSolution Latin America can support you.<br class='hide-mobile'><br class='hide-mobile'><br><br>ReSolution Latin America:<br><br>1. Designs and, in conjunction with our clients, decides on the exact strategy to be adopted.<br><br>2. Effectively follows and proactively manages the regulatory process from the planning stage all the way through to approval. Projected timelines and milestones are set-out and closely tracked.<br><br>3. Keeps our Sponsors, Investigators and ReSolution Latin America’s Project Teams up-to-date on the process, thereby enabling all functions to be on standby ready to commence as soon as approval is obtained."},{"classes":"studies","title":"FEASIBILITY STUDIES","text":"We have a direct line to the investigators and sites where the trial could be conducted. This gives us the ability to quickly and accurately pre-evaluate clinical protocols and to gauge important factors such as suitability to the region (and where in the region), recruitment potential, as well as to identify potential protocol-specific pitfalls and key success factors. Feasibility results are used to supplement our internal expertise enabling us to guide our Sponsors based on a combination of experience and empirical data. <br><br><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'>ReSolution Latin America:<br><br>1. Provides an initial expert assessment of each protocol for suitability and advises on the overall strategy that should be adopted.<br><br><br class='visible-mobile hide-desktop'>2. Evaluates the protocol with the relevant staff depending on therapeutic area, indication and product type.<br><br><br class='visible-mobile hide-desktop'>3. Prepares feasibility documentation along with questionnaires designed to obtain relevant information from potential investigators.<br><br>4. Approaches potential investigators with details of the protocol and assessment questionnaires.<br><br>5. Whether through a full Feasibility Report or through round-table discussions, provides the Sponsor with sound advice and direction on which the ultimate strategy is based."},{"classes":"supervision","title":"LOCAL/REGIONAL STUDY MANAGEMENT SUPERVISION – <span>GET YOUR STUDY BACK ON TRACK</span>","text":"Latin America may seem far away to many Sponsors and it is sometimes difficult to gauge whether or not any progress is actually being made or even what level of priority your project is being given. If this is a concern, having a local third-party offering unbiased assessment of the situation, along with support, can be an attractive proposition.<br><br><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'><br class='hide-mobile'>ReSolution Latin America:<br><br>1. Will assess the situation, gauging what aspects are working, which are not and what needs to happen to get the study back on track in order to avoid/minimize further delay.<br><br>2. Will act as a nexus between the CRO and Sponsor supervising and, if appropriate, directing progress to ensure timelines are maintained and further pitfalls are avoided."},{"classes":"expert","title":"ROUNDTABLE AND EXPERT FOCUS GROUPS","text":"The value of setting-up Expert Focus Groups can be many and varied. A protocol which is suitable for the United States or Europe is not necessarily so (throughout) Latin America. The reasons for this can be multi-factorial and are not always obvious. Furthermore, as Latin America continues to gain ground as an end-consumer of pharmaceuticals, drug development companies are increasingly taking the region into consideration for commercialization and marketing purposes.<br><br>ReSolution Latin America:<br><br>1. Can quickly set-up these types of meetings ensuring that the Expert Panel is comprised of the right expertise whilst avoiding the temptation for these forums to be too extensive in terms of participation.<br><br>2. Ensures that maximum value is obtained from these meetings and that this translates into tangible strategic benefits to the project."}]},{"classes":"clinical","title":"CLINICAL MANAGEMENT SERVICES","image":"../images/home/clinical-management_b.jpg","half":"ReSolution Latin America’s focus is on clinical research specifically in Latin America. As such, we know how to plan, implement and execute your study enabling you to reach and exceed your targets.","full":"ReSolution Latin America’s focus is on clinical research specifically in Latin America. As such, we know how to plan, implement and execute your study enabling you to reach and exceed your targets.<br><br>Our set-up and procedures, including our SOPs, are designed to match global standards and expectations to the realities of regional execution. Data from Latin America must obviously match that from other regions. This is what we ensure.","extra":"The caliber of our staff is the key to this. ReSolution Latin America’s philosophy is for our Project Teams to act as an extension of our Sponsors’ clinical departments. It is our belief that, by integrating the two, we foster a sense of ownership and accountability, thereby creating an environment in which everyone strives towards a common goal- the success of the project.<br><br>Our Project Team members are results-driven but they are held accountable to metrics and results that are important to our Sponsors rather than endless realization and percentage allocation reports.<br><br>We offer a comprehensive set of services to cover all aspects and requirements of your clinical program, including:<br><br>1. Project Management<br>2. Feasibility<br>3. Site Selection & Training<br>4. Regulatory Services<br>5. Clinical Monitoring<br>6. Investigator Meetings<br>7. Pharmacovigilance & Medical Monitoring<br>8. Quality Assurance & Auditing"},{"classes":"outsourcing","title":"OUTSOURCING SERVICES","image":"../images/home/outsourcing_b.jpg","half":"ReSolution Latin America recognizes the importance of assigning experienced clinical research professionals to your studies and the challenges associated with this given the competitive environment.","full":"ReSolution Latin America recognizes the importance of assigning experienced clinical research professionals to your studies and the challenges associated with this given the competitive environment. We are also sensitive to the particular issues of outsourcing staff in terms of being able to attract and retain talent. Our Company policies and structure have been designed to address and overcome these issues. A positive working environment, a sense of ownership and a rewards-driven culture are all conducive to the high stability of our Project Teams. Whether your requirements are for long term support or a particular issue you need to scale-up for, ReSolution Latin America can help. Our efficient set-up and lean infrastructure allows us to offer this service very cost-effectively."},{"classes":"qa","title":"QUALITY ASSURANCE","image":"../images/home/qa_b.jpg","half":"Quality is ReSolution Latin America's backbone and, as such, we invest significantly in the Quality Assurance aspect of our operations.","full":"Quality is ReSolution Latin America's backbone and, as such, we invest significantly in the Quality Assurance aspect of our operations. Through the robustness of our internal Quality System which has been repeatedly audited, the QA aspect is fully integrated into all the Company´s activities.<br><br>This enables us to offer a service which is unrivaled in the region and a par with the highest global standards.<br>Whether your requirement calls for a few site audits to a comprehensive study audit, ReSolution Latin America can support you."}]}},{"template":"investigator_appl_form","data":{"title":"about us <span>/ Investigator Application Form</span>","caption":"* ALL QUESTIONS CONTAINED IN THIS FORM ARE STRICTLY CONFIDENTIAL AND FOR INTERNAL RESOLUTION USE ONLY.","disclaimer":"I hereby agree that ReSolution may keep my details on file and contact me with possible relevant opportunities.","investigator_data":[{"action":"http://resolutioncrs.com/services/investigator_appl_form.php","method":"post"},{"classes":"form-tile first_row","label":"Name (Last, First):","input":{"id":"investigator_name","name":"investigator_name","validate":"letters","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-tile first_row","label":"Title (e.g.- Dr, Mr., Ms. etc.):","input":{"id":"investigator_title","name":"investigator_title","type":"text","validate":"title","placeholder":"","maxlength":"20"}},{"classes":"form-tile degree_row","label":"Degree (Tick all that apply):","group":[{"name":"investigator_degree[]","label":"M.D.","value":"M.D.","id":"lbl_md","type":"checkbox"},{"name":"investigator_degree[]","label":"Ph.D","value":"Ph.D","id":"lbl_phd","type":"checkbox"},{"name":"investigator_degree[]","label":"MBA","value":"MBA","id":"lbl_mba","type":"checkbox"},{"name":"investigator_degree[]","label":"Pharm. D.","value":"Pharm. D.","id":"lbl_pharmad","type":"checkbox"},{"name":"investigator_degree[]","label":"R.N.","value":"R.N.","id":"lbl_rn","type":"checkbox"}]},{"classes":"form-tile other_row","label":"Other (please specify):","input":{"id":"investigator_other","name":"investigator_other","validate":"letters-loose","type":"text","maxlength":"100"}},{"classes":"form-tile institution_row","label":"Institution/Hospital:","input":{"id":"investigator_institution","name":"investigator_institution","validate":"alphanumeric-loose","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-tile type_row","label":"Type of Institution:","group":[{"name":"investigator_typeofinstitution","type":"radio","label":"Private","value":"Private","id":"lbl_private","required":true},{"name":"investigator_typeofinstitution","type":"radio","label":"Public","value":"Public","id":"lbl_public","required":true}]},{"classes":"form-tile practicing_row","label":"Practicing Physician: ","group":[{"name":"investigator_practicingphysician","type":"radio","label":"Yes","value":"Yes","id":"lbl_y","required":true},{"name":"investigator_practicingphysician","type":"radio","label":"No","value":"No","id":"lbl_n","required":true}]},{"classes":"form-tile address_row","label":"Address 1:","input":{"id":"investigator_address1","name":"investigator_address1","validate":"alphanumeric-loose","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-tile address_row","label":"Address 2:","input":{"id":"investigator_address2","validate":"alphanumeric-loose","name":"investigator_address2","type":"text","placeholder":""}},{"classes":"form-block location_row","label":"City:","input":{"id":"investigator_city","validate":"alphanumeric-loose","name":"investigator_city","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block location_row","label":"Zip Code:","input":{"id":"investigator_zip","name":"investigator_zip","validate":"alphanumeric-strict","type":"text","placeholder":"","maxlength":"20","required":true}},{"classes":"form-block location_row","label":"Country:","input":{"id":"investigator_country","name":"investigator_country","type":"text","validate":"letters","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block location_row","label":"Telephone:","input":{"id":"investigator_telephone","name":"investigator_telephone","type":"tel","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block email_row","label":"Email:","input":{"id":"investigator_email","name":"investigator_email","type":"email","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block email_row","label":"Fax:","input":{"id":"investigator_fax","name":"investigator_fax","type":"tel","maxlength":"80","placeholder":""}},{"classes":"form-block email_row","label":"Cell Phone:","input":{"id":"investigator_cellephone","name":"investigator_cellephone","type":"tel","placeholder":"","maxlength":"80","required":true}},{"hr":true},{"title":"THERAPEUTIC SPECIALIZATION"},{"classes":"form-block therapeutic_row","label":"Therapeutic Area(s): (e.g. - oncology, infectious disease): ","input":{"id":"investigator_area","name":"investigator_area","validate":"letters-loose","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block specialization_row","label":"Sub-specialization (e.g. – pancreatic cancer, HIV): "},{"classes":"form-block sub-specialization_row","group":[{"label":"1-","id":"investigator_sub-specialization1","name":"investigator_sub-specialization1","validate":"letters-loose","type":"text","maxlength":"80","required":true},{"label":"2-","id":"investigator_sub-specialization2","name":"investigator_sub-specialization2","validate":"letters-loose","type":"text","maxlength":"80","required":true},{"label":"3-","id":"investigator_sub-specialization3","name":"investigator_sub-specialization3","validate":"letters-loose","type":"text","maxlength":"80","required":true},{"label":"Other (please specify): ","id":"investigator_Other","name":"investigator_other","validate":"letters-loose","type":"text","maxlength":"100","required":true}]},{"classes":"form-block cand_comment_row","label":"Comments (please feel free to include any relevant comments): ","textarea":{"id":"investigator_comments","name":"investigator_comments","placeholder":"","maxlength":"10000","required":true}},{"hr":{}},{"title":"CLINICAL TRIAL EXPERIENCE"},{"classes":"form-block _row","label":"Previous Clinical Trial Experience: ","input":{"id":"investigator_previousclinicaltrialexperience","name":"investigator_previousclinicaltrialexperience","type":"text","validate":"letters-loose","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block phase_row","label":"Phase: ","input":{"id":"investigator_phase","name":"investigator_phase","type":"text","validate":"letters-loose","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block phase_row","label":"Number of Trials: ","input":{"id":"investigator_numberoftrials","name":"investigator_numberoftrials","type":"text","validate":"alphanumeric","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block phase_row","label":"Phase I: ","input":{"id":"investigator_phase1","name":"investigator_phase1","type":"text","validate":"letters-loose","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block phase_row","label":"Phase II: ","input":{"id":"investigator_phase2","name":"investigator_phase2","type":"text","validate":"letters-loose","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block phase_row","label":"Phase III: ","input":{"id":"investigator_phase3","name":"investigator_phase3","type":"text","validate":"letters-loose","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block phase_row","label":"Phase IV: ","input":{"id":"investigator_phase4","name":"investigator_phase4","type":"text","validate":"letters-loose","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block _row","label":"Comments (please feel free to include any relevant comments): ","textarea":{"id":"investigator_commentsfinal","name":"investigator_commentsfinal","placeholder":"","maxlength":"10000","required":true},"hr":true},{"classes":"text-center submit","id":"submit-contact","input":{"type":"submit","value":"Submit"}}]}},{"template":"candidate_appl_form","data":{"title":"About Us <span>/ Candidate Application Form</span>","caption":"* ALL QUESTIONS CONTAINED IN THIS FORM ARE STRICTLY CONFIDENTIAL AND FOR INTERNAL RESOLUTION USE ONLY.","disclaimer":"I hereby agree that ReSolution may keep my details on file and contact me with possible relevant opportunities.","candidate_data":[{"action":"http://resolutioncrs.com/services/candidate_appl_form.php","method":"post","enctype":"multipart/form-data"},{"classes":"form-tile first_row","label":"Name (Last, First):","input":{"id":"candidate_name","name":"candidate_name","type":"text","validate":"letters","placeholder":"","maxlength":"80","required":true}},{"classes":"form-tile first_row","label":"Title (e.g.- Dr, Mr., Ms. etc.):","input":{"id":"candidate_title","name":"candidate_title","type":"text","validate":"title","placeholder":"","maxlength":"20"}},{"classes":"form-tile degree_row","label":"Degree (Tick all that apply):","group":[{"name":"candidate_degree[]","label":"M.D.","value":"M.D.","id":"M.D.","type":"checkbox"},{"name":"candidate_degree[]","label":"Ph.D","value":"Ph.D","id":"lbl_phd","type":"checkbox"},{"name":"candidate_degree[]","label":"MBA","value":"MBA","id":"lbl_mba","type":"checkbox"},{"name":"candidate_degree[]","label":"Pharm. D.","value":"Pharm. D.","id":"lbl_pharmad","type":"checkbox"},{"name":"candidate_degree[]","label":"R.N.","value":"R.N.","id":"lbl_rn","type":"checkbox"}]},{"classes":"form-tile other_row","label":"Other (please specify):","input":{"name":"candidate_other","id":"candidate_other","validate":"letters-loose","type":"text","maxlength":"100"}},{"classes":"form-tile address_row","label":"Address 1:","input":{"id":"candidate_address1","name":"candidate_address1","validate":"alphanumeric-loose","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-tile address_row","label":"Address 2:","input":{"id":"candidate_address2","name":"candidate_address2","validate":"alphanumeric-loose","type":"text","maxlength":"80","placeholder":""}},{"classes":"form-block location_row","label":"City:","input":{"id":"candidate_city","name":"candidate_city","validate":"alphanumeric-loose","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block location_row","label":"Zip Code:","input":{"id":"candidate_zip","name":"candidate_zip","validate":"alphanumeric-strict","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block location_row","label":"Country:","input":{"id":"candidate_country","name":"candidate_country","validate":"letters","type":"text","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block location_row","label":"Telephone:","input":{"id":"candidate_telephone","name":"candidate_telephone","type":"tel","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block email_row","label":"Email:","input":{"id":"candidate_email","name":"candidate_email","type":"email","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block email_row","label":"Fax:","input":{"id":"candidate_fax","name":"candidate_fax","type":"tel","maxlength":"80","placeholder":""}},{"classes":"form-block email_row","label":"Cell Phone:","input":{"id":"candidate_cellphone","name":"candidate_cellphone","type":"tel","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block position_tile","label":"Position being sought:","input":{"id":"candidate_position","name":"candidate_position","type":"text","validate":"letters-loose","placeholder":"","maxlength":"80","required":true}},{"classes":"form-block employment_tile","label":"Currently in employment:","group":[{"name":"candidate_employed","type":"radio","id":"lbl_yes","label":"Yes","required":true,"value":"Yes"},{"name":"candidate_employed","type":"radio","id":"lbl_no","label":"No","required":true,"value":"No"}]},{"classes":"form-block row_proficiency","label":"English Proficiency:","group":[{"name":"candidate_english","type":"radio","id":"lbl_adv","label":"Advanced: ","required":true,"value":"Advanced"},{"name":"candidate_english","type":"radio","id":"lbl_int","label":"Intermediate: ","required":true,"value":"Intermediate"},{"name":"candidate_english","type":"radio","id":"lbl_bsc","label":"Basic: ","required":true,"value":"Basic"}]},{"classes":"form-block row_proficiency","label":"Years of Relevant Experience:","input":{"id":"candidate_years","name":"candidate_years","type":"number","placeholder":"","required":"yeah!"}},{"classes":"form-block comment-lbl","label":"Comments (please feel free to include any relevant comments):","textarea":{"id":"candidate_comments","name":"candidate_comments","maxlength":"10000","required":true}},{"classes":"file-upload","label":"Attach CV:","input":{"id":"candidate_attachment","name":"candidate_attachment","type":"file","placeholder":"","required":"yeah"},"hr":{}},{"classes":"text-center submit","input":{"id":"submit-candidate","type":"submit","value":"Submit"}}]}}]}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/site.js?474452379